var items = {
  "block.minecraft.acacia_button": "Botón de acacia",
  "block.minecraft.acacia_door": "Puerta de acacia",
  "block.minecraft.acacia_fence": "Valla de acacia",
  "block.minecraft.acacia_fence_gate": "Puerta de valla de acacia",
  "block.minecraft.acacia_hanging_sign": "Cartel colgante de acacia",
  "block.minecraft.acacia_leaves": "Hojas de acacia",
  "block.minecraft.acacia_log": "Tronco de acacia",
  "block.minecraft.acacia_planks": "Tablones de acacia",
  "block.minecraft.acacia_pressure_plate": "Placa de presión de acacia",
  "block.minecraft.acacia_sapling": "Brote de acacia",
  "block.minecraft.acacia_shelf": "Estante de acacia",
  "block.minecraft.acacia_sign": "Cartel de acacia",
  "block.minecraft.acacia_slab": "Losa de acacia",
  "block.minecraft.acacia_stairs": "Escaleras de acacia",
  "block.minecraft.acacia_trapdoor": "Trampilla de acacia",
  "block.minecraft.acacia_wall_hanging_sign": "Cartel colgante de acacia en pared",
  "block.minecraft.acacia_wall_sign": "Cartel de acacia en pared",
  "block.minecraft.acacia_wood": "Leño de acacia",
  "block.minecraft.activator_rail": "Raíl activador",
  "block.minecraft.air": "Aire",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloque de amatista",
  "block.minecraft.amethyst_cluster": "Cúmulo de amatista",
  "block.minecraft.ancient_debris": "Escombros ancestrales",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Losa de andesita",
  "block.minecraft.andesite_stairs": "Escaleras de andesita",
  "block.minecraft.andesite_wall": "Muro de andesita",
  "block.minecraft.anvil": "Yunque",
  "block.minecraft.attached_melon_stem": "Tallo de sandía unido",
  "block.minecraft.attached_pumpkin_stem": "Tallo de calabaza unido",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Hojas de azalea",
  "block.minecraft.azure_bluet": "Azure bluet",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloque de bambú",
  "block.minecraft.bamboo_button": "Botón de bambú",
  "block.minecraft.bamboo_door": "Puerta de bambú",
  "block.minecraft.bamboo_fence": "Valla de bambú",
  "block.minecraft.bamboo_fence_gate": "Puerta de valla de bambú",
  "block.minecraft.bamboo_hanging_sign": "Cartel colgante de bambú",
  "block.minecraft.bamboo_mosaic": "Mosaico de bambú",
  "block.minecraft.bamboo_mosaic_slab": "Losa de mosaico de bambú",
  "block.minecraft.bamboo_mosaic_stairs": "Escaleras de mosaico de bambú",
  "block.minecraft.bamboo_planks": "Tablones de bambú",
  "block.minecraft.bamboo_pressure_plate": "Placa de presión de bambú",
  "block.minecraft.bamboo_sapling": "Esqueje de bambú",
  "block.minecraft.bamboo_shelf": "Estante de bambú",
  "block.minecraft.bamboo_sign": "Cartel de bambú",
  "block.minecraft.bamboo_slab": "Losa de bambú",
  "block.minecraft.bamboo_stairs": "Escaleras de bambú",
  "block.minecraft.bamboo_trapdoor": "Trampilla de bambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Cartel colgante de bambú en pared",
  "block.minecraft.bamboo_wall_sign": "Cartel de bambú en pared",
  "block.minecraft.banner.base.black": "Paño completamente negro",
  "block.minecraft.banner.base.blue": "Paño completamente azul",
  "block.minecraft.banner.base.brown": "Paño completamente marrón",
  "block.minecraft.banner.base.cyan": "Paño completamente cian",
  "block.minecraft.banner.base.gray": "Paño completamente gris",
  "block.minecraft.banner.base.green": "Paño completamente verde",
  "block.minecraft.banner.base.light_blue": "Paño completamente azul claro",
  "block.minecraft.banner.base.light_gray": "Paño completamente gris claro",
  "block.minecraft.banner.base.lime": "Paño completamente verde lima",
  "block.minecraft.banner.base.magenta": "Paño completamente magenta",
  "block.minecraft.banner.base.orange": "Paño completamente naranja",
  "block.minecraft.banner.base.pink": "Paño completamente rosa",
  "block.minecraft.banner.base.purple": "Paño completamente morado",
  "block.minecraft.banner.base.red": "Paño completamente rojo",
  "block.minecraft.banner.base.white": "Paño completamente blanco",
  "block.minecraft.banner.base.yellow": "Paño completamente amarillo",
  "block.minecraft.banner.border.black": "Bordura negra",
  "block.minecraft.banner.border.blue": "Bordura azul",
  "block.minecraft.banner.border.brown": "Bordura marrón",
  "block.minecraft.banner.border.cyan": "Bordura cian",
  "block.minecraft.banner.border.gray": "Bordura gris",
  "block.minecraft.banner.border.green": "Bordura verde",
  "block.minecraft.banner.border.light_blue": "Bordura azul claro",
  "block.minecraft.banner.border.light_gray": "Bordura gris claro",
  "block.minecraft.banner.border.lime": "Bordura verde lima",
  "block.minecraft.banner.border.magenta": "Bordura magenta",
  "block.minecraft.banner.border.orange": "Bordura naranja",
  "block.minecraft.banner.border.pink": "Bordura rosa",
  "block.minecraft.banner.border.purple": "Bordura morada",
  "block.minecraft.banner.border.red": "Bordura roja",
  "block.minecraft.banner.border.white": "Bordura blanca",
  "block.minecraft.banner.border.yellow": "Bordura amarilla",
  "block.minecraft.banner.bricks.black": "Mazonado negro",
  "block.minecraft.banner.bricks.blue": "Mazonado azul",
  "block.minecraft.banner.bricks.brown": "Mazonado marrón",
  "block.minecraft.banner.bricks.cyan": "Mazonado cian",
  "block.minecraft.banner.bricks.gray": "Mazonado gris",
  "block.minecraft.banner.bricks.green": "Mazonado verde",
  "block.minecraft.banner.bricks.light_blue": "Mazonado azul claro",
  "block.minecraft.banner.bricks.light_gray": "Mazonado gris claro",
  "block.minecraft.banner.bricks.lime": "Mazonado verde lima",
  "block.minecraft.banner.bricks.magenta": "Mazonado magenta",
  "block.minecraft.banner.bricks.orange": "Mazonado naranja",
  "block.minecraft.banner.bricks.pink": "Mazonado rosa",
  "block.minecraft.banner.bricks.purple": "Mazonado morado",
  "block.minecraft.banner.bricks.red": "Mazonado rojo",
  "block.minecraft.banner.bricks.white": "Mazonado blanco",
  "block.minecraft.banner.bricks.yellow": "Mazonado amarillo",
  "block.minecraft.banner.circle.black": "Roel negro",
  "block.minecraft.banner.circle.blue": "Roel azul",
  "block.minecraft.banner.circle.brown": "Roel marrón",
  "block.minecraft.banner.circle.cyan": "Roel cian",
  "block.minecraft.banner.circle.gray": "Roel gris",
  "block.minecraft.banner.circle.green": "Roel verde",
  "block.minecraft.banner.circle.light_blue": "Roel azul claro",
  "block.minecraft.banner.circle.light_gray": "Roel gris claro",
  "block.minecraft.banner.circle.lime": "Roel verde lima",
  "block.minecraft.banner.circle.magenta": "Roel magenta",
  "block.minecraft.banner.circle.orange": "Roel naranja",
  "block.minecraft.banner.circle.pink": "Roel rosa",
  "block.minecraft.banner.circle.purple": "Roel morado",
  "block.minecraft.banner.circle.red": "Roel rojo",
  "block.minecraft.banner.circle.white": "Roel blanco",
  "block.minecraft.banner.circle.yellow": "Roel amarillo",
  "block.minecraft.banner.creeper.black": "Estampado negro de creeper",
  "block.minecraft.banner.creeper.blue": "Estampado azul de creeper",
  "block.minecraft.banner.creeper.brown": "Estampado marrón de creeper",
  "block.minecraft.banner.creeper.cyan": "Estampado cian de creeper",
  "block.minecraft.banner.creeper.gray": "Estampado gris de creeper",
  "block.minecraft.banner.creeper.green": "Estampado verde de creeper",
  "block.minecraft.banner.creeper.light_blue": "Estampado azul claro de creeper",
  "block.minecraft.banner.creeper.light_gray": "Estampado gris claro de creeper",
  "block.minecraft.banner.creeper.lime": "Estampado verde lima de creeper",
  "block.minecraft.banner.creeper.magenta": "Estampado magenta de creeper",
  "block.minecraft.banner.creeper.orange": "Estampado naranja de creeper",
  "block.minecraft.banner.creeper.pink": "Estampado rosa de creeper",
  "block.minecraft.banner.creeper.purple": "Estampado morado de creeper",
  "block.minecraft.banner.creeper.red": "Estampado rojo de creeper",
  "block.minecraft.banner.creeper.white": "Estampado blanco de creeper",
  "block.minecraft.banner.creeper.yellow": "Estampado amarillo de creeper",
  "block.minecraft.banner.cross.black": "Aspa negra",
  "block.minecraft.banner.cross.blue": "Aspa azul",
  "block.minecraft.banner.cross.brown": "Aspa marrón",
  "block.minecraft.banner.cross.cyan": "Aspa cian",
  "block.minecraft.banner.cross.gray": "Aspa gris",
  "block.minecraft.banner.cross.green": "Aspa verde",
  "block.minecraft.banner.cross.light_blue": "Aspa azul claro",
  "block.minecraft.banner.cross.light_gray": "Aspa gris claro",
  "block.minecraft.banner.cross.lime": "Aspa verde lima",
  "block.minecraft.banner.cross.magenta": "Aspa magenta",
  "block.minecraft.banner.cross.orange": "Aspa naranja",
  "block.minecraft.banner.cross.pink": "Aspa rosa",
  "block.minecraft.banner.cross.purple": "Aspa morada",
  "block.minecraft.banner.cross.red": "Aspa roja",
  "block.minecraft.banner.cross.white": "Aspa blanca",
  "block.minecraft.banner.cross.yellow": "Aspa amarilla",
  "block.minecraft.banner.curly_border.black": "Bordura negra dentada",
  "block.minecraft.banner.curly_border.blue": "Bordura azul dentada",
  "block.minecraft.banner.curly_border.brown": "Bordura marrón dentada",
  "block.minecraft.banner.curly_border.cyan": "Bordura cian dentada",
  "block.minecraft.banner.curly_border.gray": "Bordura gris dentada",
  "block.minecraft.banner.curly_border.green": "Bordura verde dentada",
  "block.minecraft.banner.curly_border.light_blue": "Bordura azul claro dentada",
  "block.minecraft.banner.curly_border.light_gray": "Bordura gris claro dentada",
  "block.minecraft.banner.curly_border.lime": "Bordura verde lima dentada",
  "block.minecraft.banner.curly_border.magenta": "Bordura magenta dentada",
  "block.minecraft.banner.curly_border.orange": "Bordura naranja dentada",
  "block.minecraft.banner.curly_border.pink": "Bordura rosa dentada",
  "block.minecraft.banner.curly_border.purple": "Bordura morada dentada",
  "block.minecraft.banner.curly_border.red": "Bordura roja dentada",
  "block.minecraft.banner.curly_border.white": "Bordura blanca dentada",
  "block.minecraft.banner.curly_border.yellow": "Bordura amarilla dentada",
  "block.minecraft.banner.diagonal_left.black": "Tajado negro",
  "block.minecraft.banner.diagonal_left.blue": "Tajado azul",
  "block.minecraft.banner.diagonal_left.brown": "Tajado marrón",
  "block.minecraft.banner.diagonal_left.cyan": "Tajado cian",
  "block.minecraft.banner.diagonal_left.gray": "Tajado gris",
  "block.minecraft.banner.diagonal_left.green": "Tajado verde",
  "block.minecraft.banner.diagonal_left.light_blue": "Tajado azul claro",
  "block.minecraft.banner.diagonal_left.light_gray": "Tajado gris claro",
  "block.minecraft.banner.diagonal_left.lime": "Tajado verde lima",
  "block.minecraft.banner.diagonal_left.magenta": "Tajado magenta",
  "block.minecraft.banner.diagonal_left.orange": "Tajado naranja",
  "block.minecraft.banner.diagonal_left.pink": "Tajado rosa",
  "block.minecraft.banner.diagonal_left.purple": "Tajado morado",
  "block.minecraft.banner.diagonal_left.red": "Tajado rojo",
  "block.minecraft.banner.diagonal_left.white": "Tajado blanco",
  "block.minecraft.banner.diagonal_left.yellow": "Tajado amarillo",
  "block.minecraft.banner.diagonal_right.black": "Tronchado negro",
  "block.minecraft.banner.diagonal_right.blue": "Tronchado azul",
  "block.minecraft.banner.diagonal_right.brown": "Tronchado marrón",
  "block.minecraft.banner.diagonal_right.cyan": "Tronchado cian",
  "block.minecraft.banner.diagonal_right.gray": "Tronchado gris",
  "block.minecraft.banner.diagonal_right.green": "Tronchado verde",
  "block.minecraft.banner.diagonal_right.light_blue": "Tronchado azul claro",
  "block.minecraft.banner.diagonal_right.light_gray": "Tronchado gris claro",
  "block.minecraft.banner.diagonal_right.lime": "Tronchado verde lima",
  "block.minecraft.banner.diagonal_right.magenta": "Tronchado magenta",
  "block.minecraft.banner.diagonal_right.orange": "Tronchado naranja",
  "block.minecraft.banner.diagonal_right.pink": "Tronchado rosa",
  "block.minecraft.banner.diagonal_right.purple": "Tronchado morado",
  "block.minecraft.banner.diagonal_right.red": "Tronchado rojo",
  "block.minecraft.banner.diagonal_right.white": "Tronchado blanco",
  "block.minecraft.banner.diagonal_right.yellow": "Tronchado amarillo",
  "block.minecraft.banner.diagonal_up_left.black": "Tronchado negro invertido",
  "block.minecraft.banner.diagonal_up_left.blue": "Tronchado azul invertido",
  "block.minecraft.banner.diagonal_up_left.brown": "Tronchado marrón invertido",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tronchado cian invertido",
  "block.minecraft.banner.diagonal_up_left.gray": "Tronchado gris invertido",
  "block.minecraft.banner.diagonal_up_left.green": "Tronchado verde invertido",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Tronchado azul claro invertido",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Tronchado gris claro invertido",
  "block.minecraft.banner.diagonal_up_left.lime": "Tronchado verde lima invertido",
  "block.minecraft.banner.diagonal_up_left.magenta": "Tronchado magenta invertido",
  "block.minecraft.banner.diagonal_up_left.orange": "Tronchado naranja invertido",
  "block.minecraft.banner.diagonal_up_left.pink": "Tronchado rosa invertido",
  "block.minecraft.banner.diagonal_up_left.purple": "Tronchado morado invertido",
  "block.minecraft.banner.diagonal_up_left.red": "Tronchado rojo invertido",
  "block.minecraft.banner.diagonal_up_left.white": "Tronchado blanco invertido",
  "block.minecraft.banner.diagonal_up_left.yellow": "Tronchado amarillo invertido",
  "block.minecraft.banner.diagonal_up_right.black": "Tajado negro invertido",
  "block.minecraft.banner.diagonal_up_right.blue": "Tajado azul invertido",
  "block.minecraft.banner.diagonal_up_right.brown": "Tajado marrón invertido",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tajado cian invertido",
  "block.minecraft.banner.diagonal_up_right.gray": "Tajado gris invertido",
  "block.minecraft.banner.diagonal_up_right.green": "Tajado verde invertido",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tajado azul claro invertido",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tajado gris claro invertido",
  "block.minecraft.banner.diagonal_up_right.lime": "Tajado verde lima invertido",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tajado magenta invertido",
  "block.minecraft.banner.diagonal_up_right.orange": "Tajado naranja invertido",
  "block.minecraft.banner.diagonal_up_right.pink": "Tajado rosa invertido",
  "block.minecraft.banner.diagonal_up_right.purple": "Tajado morado invertido",
  "block.minecraft.banner.diagonal_up_right.red": "Tajado rojo invertido",
  "block.minecraft.banner.diagonal_up_right.white": "Tajado blanco invertido",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tajado amarillo invertido",
  "block.minecraft.banner.flow.black": "Estampado negro de espiral",
  "block.minecraft.banner.flow.blue": "Estampado azul de espiral",
  "block.minecraft.banner.flow.brown": "Estampado marrón de espiral",
  "block.minecraft.banner.flow.cyan": "Estampado cian de espiral",
  "block.minecraft.banner.flow.gray": "Estampado gris de espiral",
  "block.minecraft.banner.flow.green": "Estampado verde de espiral",
  "block.minecraft.banner.flow.light_blue": "Estampado azul claro de espiral",
  "block.minecraft.banner.flow.light_gray": "Estampado gris claro de espiral",
  "block.minecraft.banner.flow.lime": "Estampado verde lima de espiral",
  "block.minecraft.banner.flow.magenta": "Estampado magenta de espiral",
  "block.minecraft.banner.flow.orange": "Estampado naranja de espiral",
  "block.minecraft.banner.flow.pink": "Estampado rosa de espiral",
  "block.minecraft.banner.flow.purple": "Estampado morado de espiral",
  "block.minecraft.banner.flow.red": "Estampado rojo de espiral",
  "block.minecraft.banner.flow.white": "Estampado blanco de espiral",
  "block.minecraft.banner.flow.yellow": "Estampado amarillo de espiral",
  "block.minecraft.banner.flower.black": "Estampado negro de flor",
  "block.minecraft.banner.flower.blue": "Estampado azul de flor",
  "block.minecraft.banner.flower.brown": "Estampado marrón de flor",
  "block.minecraft.banner.flower.cyan": "Estampado cian de flor",
  "block.minecraft.banner.flower.gray": "Estampado gris de flor",
  "block.minecraft.banner.flower.green": "Estampado verde de flor",
  "block.minecraft.banner.flower.light_blue": "Estampado azul claro de flor",
  "block.minecraft.banner.flower.light_gray": "Estampado gris claro de flor",
  "block.minecraft.banner.flower.lime": "Estampado verde lima de flor",
  "block.minecraft.banner.flower.magenta": "Estampado magenta de flor",
  "block.minecraft.banner.flower.orange": "Estampado naranja de flor",
  "block.minecraft.banner.flower.pink": "Estampado rosa de flor",
  "block.minecraft.banner.flower.purple": "Estampado morado de flor",
  "block.minecraft.banner.flower.red": "Estampado rojo de flor",
  "block.minecraft.banner.flower.white": "Estampado blanco de flor",
  "block.minecraft.banner.flower.yellow": "Estampado amarillo de flor",
  "block.minecraft.banner.globe.black": "Estampado negro de planeta",
  "block.minecraft.banner.globe.blue": "Estampado azul de planeta",
  "block.minecraft.banner.globe.brown": "Estampado marrón de planeta",
  "block.minecraft.banner.globe.cyan": "Estampado cian de planeta",
  "block.minecraft.banner.globe.gray": "Estampado gris de planeta",
  "block.minecraft.banner.globe.green": "Estampado verde de planeta",
  "block.minecraft.banner.globe.light_blue": "Estampado azul claro de planeta",
  "block.minecraft.banner.globe.light_gray": "Estampado gris claro de planeta",
  "block.minecraft.banner.globe.lime": "Estampado verde lima de planeta",
  "block.minecraft.banner.globe.magenta": "Estampado magenta de planeta",
  "block.minecraft.banner.globe.orange": "Estampado naranja de planeta",
  "block.minecraft.banner.globe.pink": "Estampado rosa de planeta",
  "block.minecraft.banner.globe.purple": "Estampado morado de planeta",
  "block.minecraft.banner.globe.red": "Estampado rojo de planeta",
  "block.minecraft.banner.globe.white": "Estampado blanco de planeta",
  "block.minecraft.banner.globe.yellow": "Estampado amarillo de planeta",
  "block.minecraft.banner.gradient.black": "Gradiente negro",
  "block.minecraft.banner.gradient.blue": "Gradiente azul",
  "block.minecraft.banner.gradient.brown": "Gradiente marrón",
  "block.minecraft.banner.gradient.cyan": "Gradiente cian",
  "block.minecraft.banner.gradient.gray": "Gradiente gris",
  "block.minecraft.banner.gradient.green": "Gradiente verde",
  "block.minecraft.banner.gradient.light_blue": "Gradiente azul claro",
  "block.minecraft.banner.gradient.light_gray": "Gradiente gris claro",
  "block.minecraft.banner.gradient.lime": "Gradiente verde lima",
  "block.minecraft.banner.gradient.magenta": "Gradiente magenta",
  "block.minecraft.banner.gradient.orange": "Gradiente naranja",
  "block.minecraft.banner.gradient.pink": "Gradiente rosa",
  "block.minecraft.banner.gradient.purple": "Gradiente morado",
  "block.minecraft.banner.gradient.red": "Gradiente rojo",
  "block.minecraft.banner.gradient.white": "Gradiente blanco",
  "block.minecraft.banner.gradient.yellow": "Gradiente amarillo",
  "block.minecraft.banner.gradient_up.black": "Gradiente negro en campaña",
  "block.minecraft.banner.gradient_up.blue": "Gradiente azul en campaña",
  "block.minecraft.banner.gradient_up.brown": "Gradiente marrón en campaña",
  "block.minecraft.banner.gradient_up.cyan": "Gradiente cian en campaña",
  "block.minecraft.banner.gradient_up.gray": "Gradiente gris en campaña",
  "block.minecraft.banner.gradient_up.green": "Gradiente verde en campaña",
  "block.minecraft.banner.gradient_up.light_blue": "Gradiente azul claro en campaña",
  "block.minecraft.banner.gradient_up.light_gray": "Gradiente gris claro en campaña",
  "block.minecraft.banner.gradient_up.lime": "Gradiente verde lima en campaña",
  "block.minecraft.banner.gradient_up.magenta": "Gradiente magenta en campaña",
  "block.minecraft.banner.gradient_up.orange": "Gradiente naranja en campaña",
  "block.minecraft.banner.gradient_up.pink": "Gradiente rosa en campaña",
  "block.minecraft.banner.gradient_up.purple": "Gradiente morado en campaña",
  "block.minecraft.banner.gradient_up.red": "Gradiente rojo en campaña",
  "block.minecraft.banner.gradient_up.white": "Gradiente blanco en campaña",
  "block.minecraft.banner.gradient_up.yellow": "Gradiente amarillo en campaña",
  "block.minecraft.banner.guster.black": "Estampado negro de breeze",
  "block.minecraft.banner.guster.blue": "Estampado azul de breeze",
  "block.minecraft.banner.guster.brown": "Estampado marrón de breeze",
  "block.minecraft.banner.guster.cyan": "Estampado cian de breeze",
  "block.minecraft.banner.guster.gray": "Estampado gris de breeze",
  "block.minecraft.banner.guster.green": "Estampado verde de breeze",
  "block.minecraft.banner.guster.light_blue": "Estampado azul claro de breeze",
  "block.minecraft.banner.guster.light_gray": "Estampado gris claro de breeze",
  "block.minecraft.banner.guster.lime": "Estampado verde lima de breeze",
  "block.minecraft.banner.guster.magenta": "Estampado magenta de breeze",
  "block.minecraft.banner.guster.orange": "Estampado naranja de breeze",
  "block.minecraft.banner.guster.pink": "Estampado rosa de breeze",
  "block.minecraft.banner.guster.purple": "Estampado morado de breeze",
  "block.minecraft.banner.guster.red": "Estampado rojo de breeze",
  "block.minecraft.banner.guster.white": "Estampado blanco de breeze",
  "block.minecraft.banner.guster.yellow": "Estampado amarillo de breeze",
  "block.minecraft.banner.half_horizontal.black": "Cortado negro",
  "block.minecraft.banner.half_horizontal.blue": "Cortado azul",
  "block.minecraft.banner.half_horizontal.brown": "Cortado marrón",
  "block.minecraft.banner.half_horizontal.cyan": "Cortado cian",
  "block.minecraft.banner.half_horizontal.gray": "Cortado gris",
  "block.minecraft.banner.half_horizontal.green": "Cortado verde",
  "block.minecraft.banner.half_horizontal.light_blue": "Cortado azul claro",
  "block.minecraft.banner.half_horizontal.light_gray": "Cortado gris claro",
  "block.minecraft.banner.half_horizontal.lime": "Cortado verde lima",
  "block.minecraft.banner.half_horizontal.magenta": "Cortado magenta",
  "block.minecraft.banner.half_horizontal.orange": "Cortado naranja",
  "block.minecraft.banner.half_horizontal.pink": "Cortado rosa",
  "block.minecraft.banner.half_horizontal.purple": "Cortado morado",
  "block.minecraft.banner.half_horizontal.red": "Cortado rojo",
  "block.minecraft.banner.half_horizontal.white": "Cortado blanco",
  "block.minecraft.banner.half_horizontal.yellow": "Cortado amarillo",
  "block.minecraft.banner.half_horizontal_bottom.black": "Cortado negro invertido",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Cortado azul invertido",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Cortado marrón invertido",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cortado cian invertido",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Cortado gris invertido",
  "block.minecraft.banner.half_horizontal_bottom.green": "Cortado verde invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Cortado azul claro invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Cortado gris claro invertido",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Cortado verde lima invertido",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Cortado magenta invertido",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Cortado naranja invertido",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Cortado rosa invertido",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Cortado morado invertido",
  "block.minecraft.banner.half_horizontal_bottom.red": "Cortado rojo invertido",
  "block.minecraft.banner.half_horizontal_bottom.white": "Cortado blanco invertido",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Cortado amarillo invertido",
  "block.minecraft.banner.half_vertical.black": "Flanco negro",
  "block.minecraft.banner.half_vertical.blue": "Flanco azul",
  "block.minecraft.banner.half_vertical.brown": "Flanco marrón",
  "block.minecraft.banner.half_vertical.cyan": "Flanco cian",
  "block.minecraft.banner.half_vertical.gray": "Flanco gris",
  "block.minecraft.banner.half_vertical.green": "Flanco verde",
  "block.minecraft.banner.half_vertical.light_blue": "Flanco azul claro",
  "block.minecraft.banner.half_vertical.light_gray": "Flanco gris claro",
  "block.minecraft.banner.half_vertical.lime": "Flanco verde lima",
  "block.minecraft.banner.half_vertical.magenta": "Flanco magenta",
  "block.minecraft.banner.half_vertical.orange": "Flanco naranja",
  "block.minecraft.banner.half_vertical.pink": "Flanco rosa",
  "block.minecraft.banner.half_vertical.purple": "Flanco morado",
  "block.minecraft.banner.half_vertical.red": "Flanco rojo",
  "block.minecraft.banner.half_vertical.white": "Flanco blanco",
  "block.minecraft.banner.half_vertical.yellow": "Flanco amarillo",
  "block.minecraft.banner.half_vertical_right.black": "Flanco negro invertido",
  "block.minecraft.banner.half_vertical_right.blue": "Flanco azul invertido",
  "block.minecraft.banner.half_vertical_right.brown": "Flanco marrón invertido",
  "block.minecraft.banner.half_vertical_right.cyan": "Flanco cian invertido",
  "block.minecraft.banner.half_vertical_right.gray": "Flanco gris invertido",
  "block.minecraft.banner.half_vertical_right.green": "Flanco verde invertido",
  "block.minecraft.banner.half_vertical_right.light_blue": "Flanco azul claro invertido",
  "block.minecraft.banner.half_vertical_right.light_gray": "Flanco gris claro invertido",
  "block.minecraft.banner.half_vertical_right.lime": "Flanco verde lima invertido",
  "block.minecraft.banner.half_vertical_right.magenta": "Flanco magenta invertido",
  "block.minecraft.banner.half_vertical_right.orange": "Flanco naranja invertido",
  "block.minecraft.banner.half_vertical_right.pink": "Flanco rosa invertido",
  "block.minecraft.banner.half_vertical_right.purple": "Flanco morado invertido",
  "block.minecraft.banner.half_vertical_right.red": "Flanco rojo invertido",
  "block.minecraft.banner.half_vertical_right.white": "Flanco blanco invertido",
  "block.minecraft.banner.half_vertical_right.yellow": "Flanco amarillo invertido",
  "block.minecraft.banner.mojang.black": "Estampado negro de una cosa",
  "block.minecraft.banner.mojang.blue": "Estampado azul de una cosa",
  "block.minecraft.banner.mojang.brown": "Estampado marrón de una cosa",
  "block.minecraft.banner.mojang.cyan": "Estampado cian de una cosa",
  "block.minecraft.banner.mojang.gray": "Estampado gris de una cosa",
  "block.minecraft.banner.mojang.green": "Estampado verde de una cosa",
  "block.minecraft.banner.mojang.light_blue": "Estampado azul claro de una cosa",
  "block.minecraft.banner.mojang.light_gray": "Estampado gris claro de una cosa",
  "block.minecraft.banner.mojang.lime": "Estampado verde lima de una cosa",
  "block.minecraft.banner.mojang.magenta": "Estampado magenta de una cosa",
  "block.minecraft.banner.mojang.orange": "Estampado naranja de una cosa",
  "block.minecraft.banner.mojang.pink": "Estampado rosa de una cosa",
  "block.minecraft.banner.mojang.purple": "Estampado morado de una cosa",
  "block.minecraft.banner.mojang.red": "Estampado rojo de una cosa",
  "block.minecraft.banner.mojang.white": "Estampado blanco de una cosa",
  "block.minecraft.banner.mojang.yellow": "Estampado amarillo de una cosa",
  "block.minecraft.banner.piglin.black": "Estampado negro de hocico",
  "block.minecraft.banner.piglin.blue": "Estampado azul de hocico",
  "block.minecraft.banner.piglin.brown": "Estampado marrón de hocico",
  "block.minecraft.banner.piglin.cyan": "Estampado cian de hocico",
  "block.minecraft.banner.piglin.gray": "Estampado gris de hocico",
  "block.minecraft.banner.piglin.green": "Estampado verde de hocico",
  "block.minecraft.banner.piglin.light_blue": "Estampado azul claro de hocico",
  "block.minecraft.banner.piglin.light_gray": "Estampado gris claro de hocico",
  "block.minecraft.banner.piglin.lime": "Estampado verde lima de hocico",
  "block.minecraft.banner.piglin.magenta": "Estampado magenta de hocico",
  "block.minecraft.banner.piglin.orange": "Estampado naranja de hocico",
  "block.minecraft.banner.piglin.pink": "Estampado rosa de hocico",
  "block.minecraft.banner.piglin.purple": "Estampado morado de hocico",
  "block.minecraft.banner.piglin.red": "Estampado rojo de hocico",
  "block.minecraft.banner.piglin.white": "Estampado blanco de hocico",
  "block.minecraft.banner.piglin.yellow": "Estampado amarillo de hocico",
  "block.minecraft.banner.rhombus.black": "Rombo negro",
  "block.minecraft.banner.rhombus.blue": "Rombo azul",
  "block.minecraft.banner.rhombus.brown": "Rombo marrón",
  "block.minecraft.banner.rhombus.cyan": "Rombo cian",
  "block.minecraft.banner.rhombus.gray": "Rombo gris",
  "block.minecraft.banner.rhombus.green": "Rombo verde",
  "block.minecraft.banner.rhombus.light_blue": "Rombo azul claro",
  "block.minecraft.banner.rhombus.light_gray": "Rombo gris claro",
  "block.minecraft.banner.rhombus.lime": "Rombo verde lima",
  "block.minecraft.banner.rhombus.magenta": "Rombo magenta",
  "block.minecraft.banner.rhombus.orange": "Rombo naranja",
  "block.minecraft.banner.rhombus.pink": "Rombo rosa",
  "block.minecraft.banner.rhombus.purple": "Rombo morado",
  "block.minecraft.banner.rhombus.red": "Rombo rojo",
  "block.minecraft.banner.rhombus.white": "Rombo blanco",
  "block.minecraft.banner.rhombus.yellow": "Rombo amarillo",
  "block.minecraft.banner.skull.black": "Estampado negro de calavera",
  "block.minecraft.banner.skull.blue": "Estampado azul de calavera",
  "block.minecraft.banner.skull.brown": "Estampado marrón de calavera",
  "block.minecraft.banner.skull.cyan": "Estampado cian de calavera",
  "block.minecraft.banner.skull.gray": "Estampado gris de calavera",
  "block.minecraft.banner.skull.green": "Estampado verde de calavera",
  "block.minecraft.banner.skull.light_blue": "Estampado azul claro de calavera",
  "block.minecraft.banner.skull.light_gray": "Estampado gris claro de calavera",
  "block.minecraft.banner.skull.lime": "Estampado verde lima de calavera",
  "block.minecraft.banner.skull.magenta": "Estampado magenta de calavera",
  "block.minecraft.banner.skull.orange": "Estampado naranja de calavera",
  "block.minecraft.banner.skull.pink": "Estampado rosa de calavera",
  "block.minecraft.banner.skull.purple": "Estampado morado de calavera",
  "block.minecraft.banner.skull.red": "Estampado rojo de calavera",
  "block.minecraft.banner.skull.white": "Estampado blanco de calavera",
  "block.minecraft.banner.skull.yellow": "Estampado amarillo de calavera",
  "block.minecraft.banner.small_stripes.black": "Bastonado negro",
  "block.minecraft.banner.small_stripes.blue": "Bastonado azul",
  "block.minecraft.banner.small_stripes.brown": "Bastonado marrón",
  "block.minecraft.banner.small_stripes.cyan": "Bastonado cian",
  "block.minecraft.banner.small_stripes.gray": "Bastonado gris",
  "block.minecraft.banner.small_stripes.green": "Bastonado verde",
  "block.minecraft.banner.small_stripes.light_blue": "Bastonado azul claro",
  "block.minecraft.banner.small_stripes.light_gray": "Bastonado gris claro",
  "block.minecraft.banner.small_stripes.lime": "Bastonado verde lima",
  "block.minecraft.banner.small_stripes.magenta": "Bastonado magenta",
  "block.minecraft.banner.small_stripes.orange": "Bastonado naranja",
  "block.minecraft.banner.small_stripes.pink": "Bastonado rosa",
  "block.minecraft.banner.small_stripes.purple": "Bastonado morado",
  "block.minecraft.banner.small_stripes.red": "Bastonado rojo",
  "block.minecraft.banner.small_stripes.white": "Bastonado blanco",
  "block.minecraft.banner.small_stripes.yellow": "Bastonado amarillo",
  "block.minecraft.banner.square_bottom_left.black": "Cantón negro en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.blue": "Cantón azul en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.brown": "Cantón marrón en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantón cian en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.gray": "Cantón gris en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.green": "Cantón verde en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantón azul claro en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantón gris claro en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.lime": "Cantón verde lima en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantón magenta en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.orange": "Cantón naranja en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.pink": "Cantón rosa en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.purple": "Cantón morado en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.red": "Cantón rojo en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.white": "Cantón blanco en campaña a diestra",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantón amarillo en campaña a diestra",
  "block.minecraft.banner.square_bottom_right.black": "Cantón negro en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.blue": "Cantón azul en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.brown": "Cantón marrón en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantón cian en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.gray": "Cantón gris en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.green": "Cantón verde en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantón azul claro en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantón gris claro en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.lime": "Cantón verde lima en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantón magenta en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.orange": "Cantón naranja en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.pink": "Cantón rosa en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.purple": "Cantón morado en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.red": "Cantón rojo en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.white": "Cantón blanco en campaña a siniestra",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantón amarillo en campaña a siniestra",
  "block.minecraft.banner.square_top_left.black": "Cantón negro en jefe a diestra",
  "block.minecraft.banner.square_top_left.blue": "Cantón azul en jefe a diestra",
  "block.minecraft.banner.square_top_left.brown": "Cantón marrón en jefe a diestra",
  "block.minecraft.banner.square_top_left.cyan": "Cantón cian en jefe a diestra",
  "block.minecraft.banner.square_top_left.gray": "Cantón gris en jefe a diestra",
  "block.minecraft.banner.square_top_left.green": "Cantón verde en jefe a diestra",
  "block.minecraft.banner.square_top_left.light_blue": "Cantón azul claro en jefe a diestra",
  "block.minecraft.banner.square_top_left.light_gray": "Cantón gris claro en jefe a diestra",
  "block.minecraft.banner.square_top_left.lime": "Cantón verde lima en jefe a diestra",
  "block.minecraft.banner.square_top_left.magenta": "Cantón magenta en jefe a diestra",
  "block.minecraft.banner.square_top_left.orange": "Cantón naranja en jefe a diestra",
  "block.minecraft.banner.square_top_left.pink": "Cantón rosa en jefe a diestra",
  "block.minecraft.banner.square_top_left.purple": "Cantón morado en jefe a diestra",
  "block.minecraft.banner.square_top_left.red": "Cantón rojo en jefe a diestra",
  "block.minecraft.banner.square_top_left.white": "Cantón blanco en jefe a diestra",
  "block.minecraft.banner.square_top_left.yellow": "Cantón amarillo en jefe a diestra",
  "block.minecraft.banner.square_top_right.black": "Cantón negro en jefe a siniestra",
  "block.minecraft.banner.square_top_right.blue": "Cantón azul en jefe a siniestra",
  "block.minecraft.banner.square_top_right.brown": "Cantón marrón en jefe a siniestra",
  "block.minecraft.banner.square_top_right.cyan": "Cantón cian en jefe a siniestra",
  "block.minecraft.banner.square_top_right.gray": "Cantón gris en jefe a siniestra",
  "block.minecraft.banner.square_top_right.green": "Cantón verde en jefe a siniestra",
  "block.minecraft.banner.square_top_right.light_blue": "Cantón azul claro en jefe a siniestra",
  "block.minecraft.banner.square_top_right.light_gray": "Cantón gris claro en jefe a siniestra",
  "block.minecraft.banner.square_top_right.lime": "Cantón verde lima en jefe a siniestra",
  "block.minecraft.banner.square_top_right.magenta": "Cantón magenta en jefe a siniestra",
  "block.minecraft.banner.square_top_right.orange": "Cantón naranja en jefe a siniestra",
  "block.minecraft.banner.square_top_right.pink": "Cantón rosa en jefe a siniestra",
  "block.minecraft.banner.square_top_right.purple": "Cantón morado en jefe a siniestra",
  "block.minecraft.banner.square_top_right.red": "Cantón rojo en jefe a siniestra",
  "block.minecraft.banner.square_top_right.white": "Cantón blanco en jefe a siniestra",
  "block.minecraft.banner.square_top_right.yellow": "Cantón amarillo en jefe a siniestra",
  "block.minecraft.banner.straight_cross.black": "Cruz negra",
  "block.minecraft.banner.straight_cross.blue": "Cruz azul",
  "block.minecraft.banner.straight_cross.brown": "Cruz marrón",
  "block.minecraft.banner.straight_cross.cyan": "Cruz cian",
  "block.minecraft.banner.straight_cross.gray": "Cruz gris",
  "block.minecraft.banner.straight_cross.green": "Cruz verde",
  "block.minecraft.banner.straight_cross.light_blue": "Cruz azul claro",
  "block.minecraft.banner.straight_cross.light_gray": "Cruz gris claro",
  "block.minecraft.banner.straight_cross.lime": "Cruz verde lima",
  "block.minecraft.banner.straight_cross.magenta": "Cruz magenta",
  "block.minecraft.banner.straight_cross.orange": "Cruz naranja",
  "block.minecraft.banner.straight_cross.pink": "Cruz rosa",
  "block.minecraft.banner.straight_cross.purple": "Cruz morada",
  "block.minecraft.banner.straight_cross.red": "Cruz roja",
  "block.minecraft.banner.straight_cross.white": "Cruz blanca",
  "block.minecraft.banner.straight_cross.yellow": "Cruz amarilla",
  "block.minecraft.banner.stripe_bottom.black": "Campaña negra",
  "block.minecraft.banner.stripe_bottom.blue": "Campaña azul",
  "block.minecraft.banner.stripe_bottom.brown": "Campaña marrón",
  "block.minecraft.banner.stripe_bottom.cyan": "Campaña cian",
  "block.minecraft.banner.stripe_bottom.gray": "Campaña gris",
  "block.minecraft.banner.stripe_bottom.green": "Campaña verde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Campaña azul claro",
  "block.minecraft.banner.stripe_bottom.light_gray": "Campaña gris claro",
  "block.minecraft.banner.stripe_bottom.lime": "Campaña verde lima",
  "block.minecraft.banner.stripe_bottom.magenta": "Campaña magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Campaña naranja",
  "block.minecraft.banner.stripe_bottom.pink": "Campaña rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Campaña morada",
  "block.minecraft.banner.stripe_bottom.red": "Campaña roja",
  "block.minecraft.banner.stripe_bottom.white": "Campaña blanca",
  "block.minecraft.banner.stripe_bottom.yellow": "Campaña amarilla",
  "block.minecraft.banner.stripe_center.black": "Palo negro",
  "block.minecraft.banner.stripe_center.blue": "Palo azul",
  "block.minecraft.banner.stripe_center.brown": "Palo marrón",
  "block.minecraft.banner.stripe_center.cyan": "Palo cian",
  "block.minecraft.banner.stripe_center.gray": "Palo gris",
  "block.minecraft.banner.stripe_center.green": "Palo verde",
  "block.minecraft.banner.stripe_center.light_blue": "Palo azul claro",
  "block.minecraft.banner.stripe_center.light_gray": "Palo gris claro",
  "block.minecraft.banner.stripe_center.lime": "Palo verde lima",
  "block.minecraft.banner.stripe_center.magenta": "Palo magenta",
  "block.minecraft.banner.stripe_center.orange": "Palo naranja",
  "block.minecraft.banner.stripe_center.pink": "Palo rosa",
  "block.minecraft.banner.stripe_center.purple": "Palo morado",
  "block.minecraft.banner.stripe_center.red": "Palo rojo",
  "block.minecraft.banner.stripe_center.white": "Palo blanco",
  "block.minecraft.banner.stripe_center.yellow": "Palo amarillo",
  "block.minecraft.banner.stripe_downleft.black": "Banda negra a siniestra",
  "block.minecraft.banner.stripe_downleft.blue": "Banda azul a siniestra",
  "block.minecraft.banner.stripe_downleft.brown": "Banda marrón a siniestra",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda cian a siniestra",
  "block.minecraft.banner.stripe_downleft.gray": "Banda gris a siniestra",
  "block.minecraft.banner.stripe_downleft.green": "Banda verde a siniestra",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda azul claro a siniestra",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda gris claro a siniestra",
  "block.minecraft.banner.stripe_downleft.lime": "Banda verde lima a siniestra",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda magenta a siniestra",
  "block.minecraft.banner.stripe_downleft.orange": "Banda naranja a siniestra",
  "block.minecraft.banner.stripe_downleft.pink": "Banda rosa a siniestra",
  "block.minecraft.banner.stripe_downleft.purple": "Banda morada a siniestra",
  "block.minecraft.banner.stripe_downleft.red": "Banda roja a siniestra",
  "block.minecraft.banner.stripe_downleft.white": "Banda blanca a siniestra",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda amarilla a siniestra",
  "block.minecraft.banner.stripe_downright.black": "Banda negra",
  "block.minecraft.banner.stripe_downright.blue": "Banda azul",
  "block.minecraft.banner.stripe_downright.brown": "Banda marrón",
  "block.minecraft.banner.stripe_downright.cyan": "Banda cian",
  "block.minecraft.banner.stripe_downright.gray": "Banda gris",
  "block.minecraft.banner.stripe_downright.green": "Banda verde",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda azul claro",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda gris claro",
  "block.minecraft.banner.stripe_downright.lime": "Banda verde lima",
  "block.minecraft.banner.stripe_downright.magenta": "Banda magenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda naranja",
  "block.minecraft.banner.stripe_downright.pink": "Banda rosa",
  "block.minecraft.banner.stripe_downright.purple": "Banda morada",
  "block.minecraft.banner.stripe_downright.red": "Banda roja",
  "block.minecraft.banner.stripe_downright.white": "Banda blanca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda amarilla",
  "block.minecraft.banner.stripe_left.black": "Palo negro a diestra",
  "block.minecraft.banner.stripe_left.blue": "Palo azul a diestra",
  "block.minecraft.banner.stripe_left.brown": "Palo marrón a diestra",
  "block.minecraft.banner.stripe_left.cyan": "Palo cian a diestra",
  "block.minecraft.banner.stripe_left.gray": "Palo gris a diestra",
  "block.minecraft.banner.stripe_left.green": "Palo verde a diestra",
  "block.minecraft.banner.stripe_left.light_blue": "Palo azul claro a diestra",
  "block.minecraft.banner.stripe_left.light_gray": "Palo gris claro a diestra",
  "block.minecraft.banner.stripe_left.lime": "Palo verde lima a diestra",
  "block.minecraft.banner.stripe_left.magenta": "Palo magenta a diestra",
  "block.minecraft.banner.stripe_left.orange": "Palo naranja a diestra",
  "block.minecraft.banner.stripe_left.pink": "Palo rosa a diestra",
  "block.minecraft.banner.stripe_left.purple": "Palo morado a diestra",
  "block.minecraft.banner.stripe_left.red": "Palo rojo a diestra",
  "block.minecraft.banner.stripe_left.white": "Palo blanco a diestra",
  "block.minecraft.banner.stripe_left.yellow": "Palo amarillo a diestra",
  "block.minecraft.banner.stripe_middle.black": "Franja negra",
  "block.minecraft.banner.stripe_middle.blue": "Franja azul",
  "block.minecraft.banner.stripe_middle.brown": "Franja marrón",
  "block.minecraft.banner.stripe_middle.cyan": "Franja cian",
  "block.minecraft.banner.stripe_middle.gray": "Franja gris",
  "block.minecraft.banner.stripe_middle.green": "Franja verde",
  "block.minecraft.banner.stripe_middle.light_blue": "Franja azul claro",
  "block.minecraft.banner.stripe_middle.light_gray": "Franja gris claro",
  "block.minecraft.banner.stripe_middle.lime": "Franja verde lima",
  "block.minecraft.banner.stripe_middle.magenta": "Franja magenta",
  "block.minecraft.banner.stripe_middle.orange": "Franja naranja",
  "block.minecraft.banner.stripe_middle.pink": "Franja rosa",
  "block.minecraft.banner.stripe_middle.purple": "Franja morada",
  "block.minecraft.banner.stripe_middle.red": "Franja roja",
  "block.minecraft.banner.stripe_middle.white": "Franja blanca",
  "block.minecraft.banner.stripe_middle.yellow": "Franja amarilla",
  "block.minecraft.banner.stripe_right.black": "Palo negro a siniestra",
  "block.minecraft.banner.stripe_right.blue": "Palo azul a siniestra",
  "block.minecraft.banner.stripe_right.brown": "Palo marrón a siniestra",
  "block.minecraft.banner.stripe_right.cyan": "Palo cian a siniestra",
  "block.minecraft.banner.stripe_right.gray": "Palo gris a siniestra",
  "block.minecraft.banner.stripe_right.green": "Palo verde a siniestra",
  "block.minecraft.banner.stripe_right.light_blue": "Palo azul claro a siniestra",
  "block.minecraft.banner.stripe_right.light_gray": "Palo gris claro a siniestra",
  "block.minecraft.banner.stripe_right.lime": "Palo verde lima a siniestra",
  "block.minecraft.banner.stripe_right.magenta": "Palo magenta a siniestra",
  "block.minecraft.banner.stripe_right.orange": "Palo naranja a siniestra",
  "block.minecraft.banner.stripe_right.pink": "Palo rosa a siniestra",
  "block.minecraft.banner.stripe_right.purple": "Palo morado a siniestra",
  "block.minecraft.banner.stripe_right.red": "Palo rojo a siniestra",
  "block.minecraft.banner.stripe_right.white": "Palo blanco a siniestra",
  "block.minecraft.banner.stripe_right.yellow": "Palo amarillo a siniestra",
  "block.minecraft.banner.stripe_top.black": "Jefe negro",
  "block.minecraft.banner.stripe_top.blue": "Jefe azul",
  "block.minecraft.banner.stripe_top.brown": "Jefe marrón",
  "block.minecraft.banner.stripe_top.cyan": "Jefe cian",
  "block.minecraft.banner.stripe_top.gray": "Jefe gris",
  "block.minecraft.banner.stripe_top.green": "Jefe verde",
  "block.minecraft.banner.stripe_top.light_blue": "Jefe azul claro",
  "block.minecraft.banner.stripe_top.light_gray": "Jefe gris claro",
  "block.minecraft.banner.stripe_top.lime": "Jefe verde lima",
  "block.minecraft.banner.stripe_top.magenta": "Jefe magenta",
  "block.minecraft.banner.stripe_top.orange": "Jefe naranja",
  "block.minecraft.banner.stripe_top.pink": "Jefe rosa",
  "block.minecraft.banner.stripe_top.purple": "Jefe morado",
  "block.minecraft.banner.stripe_top.red": "Jefe rojo",
  "block.minecraft.banner.stripe_top.white": "Jefe blanco",
  "block.minecraft.banner.stripe_top.yellow": "Jefe amarillo",
  "block.minecraft.banner.triangle_bottom.black": "Chevrón negro",
  "block.minecraft.banner.triangle_bottom.blue": "Chevrón azul",
  "block.minecraft.banner.triangle_bottom.brown": "Chevrón marrón",
  "block.minecraft.banner.triangle_bottom.cyan": "Chevrón cian",
  "block.minecraft.banner.triangle_bottom.gray": "Chevrón gris",
  "block.minecraft.banner.triangle_bottom.green": "Chevrón verde",
  "block.minecraft.banner.triangle_bottom.light_blue": "Chevrón azul claro",
  "block.minecraft.banner.triangle_bottom.light_gray": "Chevrón gris claro",
  "block.minecraft.banner.triangle_bottom.lime": "Chevrón verde lima",
  "block.minecraft.banner.triangle_bottom.magenta": "Chevrón magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Chevrón naranja",
  "block.minecraft.banner.triangle_bottom.pink": "Chevrón rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Chevrón morado",
  "block.minecraft.banner.triangle_bottom.red": "Chevrón rojo",
  "block.minecraft.banner.triangle_bottom.white": "Chevrón blanco",
  "block.minecraft.banner.triangle_bottom.yellow": "Chevrón amarillo",
  "block.minecraft.banner.triangle_top.black": "Chevrón negro invertido",
  "block.minecraft.banner.triangle_top.blue": "Chevrón azul invertido",
  "block.minecraft.banner.triangle_top.brown": "Chevrón marrón invertido",
  "block.minecraft.banner.triangle_top.cyan": "Chevrón cian invertido",
  "block.minecraft.banner.triangle_top.gray": "Chevrón gris invertido",
  "block.minecraft.banner.triangle_top.green": "Chevrón verde invertido",
  "block.minecraft.banner.triangle_top.light_blue": "Chevrón azul claro invertido",
  "block.minecraft.banner.triangle_top.light_gray": "Chevrón gris claro invertido",
  "block.minecraft.banner.triangle_top.lime": "Chevrón verde lima invertido",
  "block.minecraft.banner.triangle_top.magenta": "Chevrón magenta invertido",
  "block.minecraft.banner.triangle_top.orange": "Chevrón naranja invertido",
  "block.minecraft.banner.triangle_top.pink": "Chevrón rosa invertido",
  "block.minecraft.banner.triangle_top.purple": "Chevrón morado invertido",
  "block.minecraft.banner.triangle_top.red": "Chevrón rojo invertido",
  "block.minecraft.banner.triangle_top.white": "Chevrón blanco invertido",
  "block.minecraft.banner.triangle_top.yellow": "Chevrón amarillo invertido",
  "block.minecraft.banner.triangles_bottom.black": "Campaña negra dentada",
  "block.minecraft.banner.triangles_bottom.blue": "Campaña azul dentada",
  "block.minecraft.banner.triangles_bottom.brown": "Campaña marrón dentada",
  "block.minecraft.banner.triangles_bottom.cyan": "Campaña cian dentada",
  "block.minecraft.banner.triangles_bottom.gray": "Campaña gris dentada",
  "block.minecraft.banner.triangles_bottom.green": "Campaña verde dentada",
  "block.minecraft.banner.triangles_bottom.light_blue": "Campaña azul claro dentada",
  "block.minecraft.banner.triangles_bottom.light_gray": "Campaña gris claro dentada",
  "block.minecraft.banner.triangles_bottom.lime": "Campaña verde lima dentada",
  "block.minecraft.banner.triangles_bottom.magenta": "Campaña magenta dentada",
  "block.minecraft.banner.triangles_bottom.orange": "Campaña naranja dentada",
  "block.minecraft.banner.triangles_bottom.pink": "Campaña rosa dentada",
  "block.minecraft.banner.triangles_bottom.purple": "Campaña morada dentada",
  "block.minecraft.banner.triangles_bottom.red": "Campaña roja dentada",
  "block.minecraft.banner.triangles_bottom.white": "Campaña blanca dentada",
  "block.minecraft.banner.triangles_bottom.yellow": "Campaña amarilla dentada",
  "block.minecraft.banner.triangles_top.black": "Jefe negro dentado",
  "block.minecraft.banner.triangles_top.blue": "Jefe azul dentado",
  "block.minecraft.banner.triangles_top.brown": "Jefe marrón dentado",
  "block.minecraft.banner.triangles_top.cyan": "Jefe cian dentado",
  "block.minecraft.banner.triangles_top.gray": "Jefe gris dentado",
  "block.minecraft.banner.triangles_top.green": "Jefe verde dentado",
  "block.minecraft.banner.triangles_top.light_blue": "Jefe azul claro dentado",
  "block.minecraft.banner.triangles_top.light_gray": "Jefe gris claro dentado",
  "block.minecraft.banner.triangles_top.lime": "Jefe verde lima dentado",
  "block.minecraft.banner.triangles_top.magenta": "Jefe magenta dentado",
  "block.minecraft.banner.triangles_top.orange": "Jefe naranja dentado",
  "block.minecraft.banner.triangles_top.pink": "Jefe rosa dentado",
  "block.minecraft.banner.triangles_top.purple": "Jefe morado dentado",
  "block.minecraft.banner.triangles_top.red": "Jefe rojo dentado",
  "block.minecraft.banner.triangles_top.white": "Jefe blanco dentado",
  "block.minecraft.banner.triangles_top.yellow": "Jefe amarillo dentado",
  "block.minecraft.barrel": "Barril",
  "block.minecraft.barrier": "Barrera",
  "block.minecraft.basalt": "Basalto",
  "block.minecraft.beacon": "Faro",
  "block.minecraft.beacon.primary": "Poder principal",
  "block.minecraft.beacon.secondary": "Poder secundario",
  "block.minecraft.bed.no_sleep": "Solo puedes dormir por la noche o durante tormentas eléctricas",
  "block.minecraft.bed.not_safe": "No puedes dormir ahora: hay monstruos cerca",
  "block.minecraft.bed.obstructed": "Esta cama está obstruida",
  "block.minecraft.bed.occupied": "Esta cama está ocupada",
  "block.minecraft.bed.too_far_away": "No puedes dormir ahora: la cama está muy lejos",
  "block.minecraft.bedrock": "Piedra base",
  "block.minecraft.bee_nest": "Colmena",
  "block.minecraft.beehive": "Apiario",
  "block.minecraft.beetroots": "Remolachas",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Plantaforma grande",
  "block.minecraft.big_dripleaf_stem": "Tallo de plantaforma grande",
  "block.minecraft.birch_button": "Botón de abedul",
  "block.minecraft.birch_door": "Puerta de abedul",
  "block.minecraft.birch_fence": "Valla de abedul",
  "block.minecraft.birch_fence_gate": "Puerta de valla de abedul",
  "block.minecraft.birch_hanging_sign": "Cartel colgante de abedul",
  "block.minecraft.birch_leaves": "Hojas de abedul",
  "block.minecraft.birch_log": "Tronco de abedul",
  "block.minecraft.birch_planks": "Tablones de abedul",
  "block.minecraft.birch_pressure_plate": "Placa de presión de abedul",
  "block.minecraft.birch_sapling": "Brote de abedul",
  "block.minecraft.birch_shelf": "Estante de abedul",
  "block.minecraft.birch_sign": "Cartel de abedul",
  "block.minecraft.birch_slab": "Losa de abedul",
  "block.minecraft.birch_stairs": "Escaleras de abedul",
  "block.minecraft.birch_trapdoor": "Trampilla de abedul",
  "block.minecraft.birch_wall_hanging_sign": "Cartel colgante de abedul en pared",
  "block.minecraft.birch_wall_sign": "Cartel de abedul en pared",
  "block.minecraft.birch_wood": "Leño de abedul",
  "block.minecraft.black_banner": "Estandarte negro",
  "block.minecraft.black_bed": "Cama negra",
  "block.minecraft.black_candle": "Vela negra",
  "block.minecraft.black_candle_cake": "Tarta con vela negra",
  "block.minecraft.black_carpet": "Alfombra negra",
  "block.minecraft.black_concrete": "Hormigón negro",
  "block.minecraft.black_concrete_powder": "Cemento negro",
  "block.minecraft.black_glazed_terracotta": "Azulejo negro",
  "block.minecraft.black_shulker_box": "Caja de shulker negra",
  "block.minecraft.black_stained_glass": "Cristal tintado de negro",
  "block.minecraft.black_stained_glass_pane": "Panel de cristal tintado de negro",
  "block.minecraft.black_terracotta": "Terracota negra",
  "block.minecraft.black_wool": "Lana negra",
  "block.minecraft.blackstone": "Piedra negra",
  "block.minecraft.blackstone_slab": "Losa de piedra negra",
  "block.minecraft.blackstone_stairs": "Escaleras de piedra negra",
  "block.minecraft.blackstone_wall": "Muro de piedra negra",
  "block.minecraft.blast_furnace": "Alto horno",
  "block.minecraft.blue_banner": "Estandarte azul",
  "block.minecraft.blue_bed": "Cama azul",
  "block.minecraft.blue_candle": "Vela azul",
  "block.minecraft.blue_candle_cake": "Tarta con vela azul",
  "block.minecraft.blue_carpet": "Alfombra azul",
  "block.minecraft.blue_concrete": "Hormigón azul",
  "block.minecraft.blue_concrete_powder": "Cemento azul",
  "block.minecraft.blue_glazed_terracotta": "Azulejo azul",
  "block.minecraft.blue_ice": "Hielo azul",
  "block.minecraft.blue_orchid": "Orquídea azul",
  "block.minecraft.blue_shulker_box": "Caja de shulker azul",
  "block.minecraft.blue_stained_glass": "Cristal tintado de azul",
  "block.minecraft.blue_stained_glass_pane": "Panel de cristal tintado de azul",
  "block.minecraft.blue_terracotta": "Terracota azul",
  "block.minecraft.blue_wool": "Lana azul",
  "block.minecraft.bone_block": "Bloque de huesos",
  "block.minecraft.bookshelf": "Librería",
  "block.minecraft.brain_coral": "Coral de cerebro",
  "block.minecraft.brain_coral_block": "Bloque de coral de cerebro",
  "block.minecraft.brain_coral_fan": "Gorgonia de cerebro",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia de cerebro en pared",
  "block.minecraft.brewing_stand": "Soporte para pociones",
  "block.minecraft.brick_slab": "Losa de ladrillos",
  "block.minecraft.brick_stairs": "Escaleras de ladrillos",
  "block.minecraft.brick_wall": "Muro de ladrillos",
  "block.minecraft.bricks": "Ladrillos",
  "block.minecraft.brown_banner": "Estandarte marrón",
  "block.minecraft.brown_bed": "Cama marrón",
  "block.minecraft.brown_candle": "Vela marrón",
  "block.minecraft.brown_candle_cake": "Tarta con vela marrón",
  "block.minecraft.brown_carpet": "Alfombra marrón",
  "block.minecraft.brown_concrete": "Hormigón marrón",
  "block.minecraft.brown_concrete_powder": "Cemento marrón",
  "block.minecraft.brown_glazed_terracotta": "Azulejo marrón",
  "block.minecraft.brown_mushroom": "Champiñón marrón",
  "block.minecraft.brown_mushroom_block": "Bloque de champiñón marrón",
  "block.minecraft.brown_shulker_box": "Caja de shulker marrón",
  "block.minecraft.brown_stained_glass": "Cristal tintado de marrón",
  "block.minecraft.brown_stained_glass_pane": "Panel de cristal tintado de marrón",
  "block.minecraft.brown_terracotta": "Terracota marrón",
  "block.minecraft.brown_wool": "Lana marrón",
  "block.minecraft.bubble_column": "Columna de burbujas",
  "block.minecraft.bubble_coral": "Coral de burbuja",
  "block.minecraft.bubble_coral_block": "Bloque de coral de burbuja",
  "block.minecraft.bubble_coral_fan": "Gorgonia de burbuja",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia de burbuja en pared",
  "block.minecraft.budding_amethyst": "Brotador de amatista",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Flor de cactus",
  "block.minecraft.cake": "Tarta",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Sensor de sculk calibrado",
  "block.minecraft.campfire": "Hoguera",
  "block.minecraft.candle": "Vela",
  "block.minecraft.candle_cake": "Tarta con vela",
  "block.minecraft.carrots": "Zanahorias",
  "block.minecraft.cartography_table": "Mesa de cartografía",
  "block.minecraft.carved_pumpkin": "Calabaza tallada",
  "block.minecraft.cauldron": "Caldero",
  "block.minecraft.cave_air": "Aire de cueva",
  "block.minecraft.cave_vines": "Enredaderas de cueva",
  "block.minecraft.cave_vines_plant": "Tallo de enredaderas de cueva",
  "block.minecraft.chain": "Cadena",
  "block.minecraft.chain_command_block": "Bloque de comandos en cadena",
  "block.minecraft.cherry_button": "Botón de cerezo",
  "block.minecraft.cherry_door": "Puerta de cerezo",
  "block.minecraft.cherry_fence": "Valla de cerezo",
  "block.minecraft.cherry_fence_gate": "Puerta de valla de cerezo",
  "block.minecraft.cherry_hanging_sign": "Cartel colgante de cerezo",
  "block.minecraft.cherry_leaves": "Hojas de cerezo",
  "block.minecraft.cherry_log": "Tronco de cerezo",
  "block.minecraft.cherry_planks": "Tablones de cerezo",
  "block.minecraft.cherry_pressure_plate": "Placa de presión de cerezo",
  "block.minecraft.cherry_sapling": "Brote de cerezo",
  "block.minecraft.cherry_shelf": "Estante de cerezo",
  "block.minecraft.cherry_sign": "Cartel de cerezo",
  "block.minecraft.cherry_slab": "Losa de cerezo",
  "block.minecraft.cherry_stairs": "Escaleras de cerezo",
  "block.minecraft.cherry_trapdoor": "Trampilla de cerezo",
  "block.minecraft.cherry_wall_hanging_sign": "Cartel colgante de cerezo en pared",
  "block.minecraft.cherry_wall_sign": "Cartel colgante de cerezo",
  "block.minecraft.cherry_wood": "Leño de cerezo",
  "block.minecraft.chest": "Cofre",
  "block.minecraft.chipped_anvil": "Yunque dañado",
  "block.minecraft.chiseled_bookshelf": "Estantería",
  "block.minecraft.chiseled_copper": "Cobre cincelado",
  "block.minecraft.chiseled_deepslate": "Pizarra profunda cincelada",
  "block.minecraft.chiseled_nether_bricks": "Ladrillos del Nether cincelados",
  "block.minecraft.chiseled_polished_blackstone": "Piedra negra pulida cincelada",
  "block.minecraft.chiseled_quartz_block": "Cuarzo cincelado",
  "block.minecraft.chiseled_red_sandstone": "Arenisca roja cincelada",
  "block.minecraft.chiseled_resin_bricks": "Ladrillos de resina cincelados",
  "block.minecraft.chiseled_sandstone": "Arenisca cincelada",
  "block.minecraft.chiseled_stone_bricks": "Ladrillos de piedra cincelados",
  "block.minecraft.chiseled_tuff": "Toba cincelada",
  "block.minecraft.chiseled_tuff_bricks": "Ladrillos de toba cincelados",
  "block.minecraft.chorus_flower": "Flor chorus",
  "block.minecraft.chorus_plant": "Planta chorus",
  "block.minecraft.clay": "Bloque de arcilla",
  "block.minecraft.closed_eyeblossom": "Miraflor cerrada",
  "block.minecraft.coal_block": "Bloque de carbón",
  "block.minecraft.coal_ore": "Mena de carbón",
  "block.minecraft.coarse_dirt": "Tierra estéril",
  "block.minecraft.cobbled_deepslate": "Pizarra profunda rocosa",
  "block.minecraft.cobbled_deepslate_slab": "Losa de pizarra profunda rocosa",
  "block.minecraft.cobbled_deepslate_stairs": "Escaleras de pizarra profunda rocosa",
  "block.minecraft.cobbled_deepslate_wall": "Muro de pizarra profunda rocosa",
  "block.minecraft.cobblestone": "Roca",
  "block.minecraft.cobblestone_slab": "Losa de roca",
  "block.minecraft.cobblestone_stairs": "Escaleras de roca",
  "block.minecraft.cobblestone_wall": "Muro de roca",
  "block.minecraft.cobweb": "Telaraña",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Bloque de comandos",
  "block.minecraft.comparator": "Comparador de redstone",
  "block.minecraft.composter": "Compostador",
  "block.minecraft.conduit": "Canalizador",
  "block.minecraft.copper_bars": "Barrotes de cobre",
  "block.minecraft.copper_block": "Bloque de cobre",
  "block.minecraft.copper_bulb": "Lámpara de cobre",
  "block.minecraft.copper_chain": "Cadena de cobre",
  "block.minecraft.copper_chest": "Cofre de cobre",
  "block.minecraft.copper_door": "Puerta de cobre",
  "block.minecraft.copper_golem_statue": "Estatua de gólem de cobre",
  "block.minecraft.copper_grate": "Rejilla de cobre",
  "block.minecraft.copper_lantern": "Farol de cobre",
  "block.minecraft.copper_ore": "Mena de cobre",
  "block.minecraft.copper_torch": "Antorcha de cobre",
  "block.minecraft.copper_trapdoor": "Trampilla de cobre",
  "block.minecraft.copper_wall_torch": "Antorcha de cobre en pared",
  "block.minecraft.cornflower": "Aciano",
  "block.minecraft.cracked_deepslate_bricks": "Ladrillos de pizarra profunda agrietados",
  "block.minecraft.cracked_deepslate_tiles": "Baldosas de pizarra profunda agrietadas",
  "block.minecraft.cracked_nether_bricks": "Ladrillos del Nether agrietados",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ladrillos de piedra negra pulida agrietados",
  "block.minecraft.cracked_stone_bricks": "Ladrillos de piedra agrietados",
  "block.minecraft.crafter": "Fabricador",
  "block.minecraft.crafting_table": "Mesa de trabajo",
  "block.minecraft.creaking_heart": "Corazón de crepitante",
  "block.minecraft.creeper_head": "Cabeza de creeper",
  "block.minecraft.creeper_wall_head": "Cabeza de creeper en pared",
  "block.minecraft.crimson_button": "Botón carmesí",
  "block.minecraft.crimson_door": "Puerta carmesí",
  "block.minecraft.crimson_fence": "Valla carmesí",
  "block.minecraft.crimson_fence_gate": "Puerta de valla carmesí",
  "block.minecraft.crimson_fungus": "Hongo carmesí",
  "block.minecraft.crimson_hanging_sign": "Cartel colgante carmesí",
  "block.minecraft.crimson_hyphae": "Hifas carmesí",
  "block.minecraft.crimson_nylium": "Necelio carmesí",
  "block.minecraft.crimson_planks": "Tablones carmesí",
  "block.minecraft.crimson_pressure_plate": "Placa de presión carmesí",
  "block.minecraft.crimson_roots": "Raíces carmesí",
  "block.minecraft.crimson_shelf": "Estante carmesí",
  "block.minecraft.crimson_sign": "Cartel carmesí",
  "block.minecraft.crimson_slab": "Losa carmesí",
  "block.minecraft.crimson_stairs": "Escaleras carmesí",
  "block.minecraft.crimson_stem": "Tallo carmesí",
  "block.minecraft.crimson_trapdoor": "Trampilla carmesí",
  "block.minecraft.crimson_wall_hanging_sign": "Cartel colgante carmesí en pared",
  "block.minecraft.crimson_wall_sign": "Cartel carmesí en pared",
  "block.minecraft.crying_obsidian": "Obsidiana llorosa",
  "block.minecraft.cut_copper": "Cobre cortado",
  "block.minecraft.cut_copper_slab": "Losa de cobre cortado",
  "block.minecraft.cut_copper_stairs": "Escaleras de cobre cortado",
  "block.minecraft.cut_red_sandstone": "Arenisca roja cortada",
  "block.minecraft.cut_red_sandstone_slab": "Losa de arenisca roja cortada",
  "block.minecraft.cut_sandstone": "Arenisca cortada",
  "block.minecraft.cut_sandstone_slab": "Losa de arenisca cortada",
  "block.minecraft.cyan_banner": "Estandarte cian",
  "block.minecraft.cyan_bed": "Cama cian",
  "block.minecraft.cyan_candle": "Vela cian",
  "block.minecraft.cyan_candle_cake": "Tarta con vela cian",
  "block.minecraft.cyan_carpet": "Alfombra cian",
  "block.minecraft.cyan_concrete": "Hormigón cian",
  "block.minecraft.cyan_concrete_powder": "Cemento cian",
  "block.minecraft.cyan_glazed_terracotta": "Azulejo cian",
  "block.minecraft.cyan_shulker_box": "Caja de shulker cian",
  "block.minecraft.cyan_stained_glass": "Cristal tintado de cian",
  "block.minecraft.cyan_stained_glass_pane": "Panel de cristal tintado de cian",
  "block.minecraft.cyan_terracotta": "Terracota cian",
  "block.minecraft.cyan_wool": "Lana cian",
  "block.minecraft.damaged_anvil": "Yunque muy dañado",
  "block.minecraft.dandelion": "Diente de león",
  "block.minecraft.dark_oak_button": "Botón de roble oscuro",
  "block.minecraft.dark_oak_door": "Puerta de roble oscuro",
  "block.minecraft.dark_oak_fence": "Valla de roble oscuro",
  "block.minecraft.dark_oak_fence_gate": "Puerta de valla de roble oscuro",
  "block.minecraft.dark_oak_hanging_sign": "Cartel colgante de roble oscuro",
  "block.minecraft.dark_oak_leaves": "Hojas de roble oscuro",
  "block.minecraft.dark_oak_log": "Tronco de roble oscuro",
  "block.minecraft.dark_oak_planks": "Tablones de roble oscuro",
  "block.minecraft.dark_oak_pressure_plate": "Placa de presión de roble oscuro",
  "block.minecraft.dark_oak_sapling": "Brote de roble oscuro",
  "block.minecraft.dark_oak_shelf": "Estante de roble oscuro",
  "block.minecraft.dark_oak_sign": "Cartel de roble oscuro",
  "block.minecraft.dark_oak_slab": "Losa de roble oscuro",
  "block.minecraft.dark_oak_stairs": "Escaleras de roble oscuro",
  "block.minecraft.dark_oak_trapdoor": "Trampilla de roble oscuro",
  "block.minecraft.dark_oak_wall_hanging_sign": "Cartel colgante de roble oscuro en pared",
  "block.minecraft.dark_oak_wall_sign": "Cartel de roble oscuro en pared",
  "block.minecraft.dark_oak_wood": "Leño de roble oscuro",
  "block.minecraft.dark_prismarine": "Prismarina oscura",
  "block.minecraft.dark_prismarine_slab": "Losa de prismarina oscura",
  "block.minecraft.dark_prismarine_stairs": "Escaleras de prismarina oscura",
  "block.minecraft.daylight_detector": "Sensor de luz solar",
  "block.minecraft.dead_brain_coral": "Coral de cerebro muerto",
  "block.minecraft.dead_brain_coral_block": "Bloque de coral de cerebro muerto",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia de cerebro muerta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia de cerebro muerta en pared",
  "block.minecraft.dead_bubble_coral": "Coral de burbuja muerto",
  "block.minecraft.dead_bubble_coral_block": "Bloque de coral de burbuja muerto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia de burbuja muerta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia de burbuja muerta en pared",
  "block.minecraft.dead_bush": "Arbusto muerto",
  "block.minecraft.dead_fire_coral": "Coral de fuego muerto",
  "block.minecraft.dead_fire_coral_block": "Bloque de coral de fuego muerto",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia de fuego muerta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia de fuego muerta en pared",
  "block.minecraft.dead_horn_coral": "Coral de cuerno muerto",
  "block.minecraft.dead_horn_coral_block": "Bloque de coral de cuerno muerto",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia de cuerno muerta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia de cuerno muerta en pared",
  "block.minecraft.dead_tube_coral": "Coral de tubo muerto",
  "block.minecraft.dead_tube_coral_block": "Bloque de coral de tubo muerto",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia de tubo muerta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia de tubo muerta en pared",
  "block.minecraft.decorated_pot": "Vasija decorada",
  "block.minecraft.deepslate": "Pizarra profunda",
  "block.minecraft.deepslate_brick_slab": "Losa de ladrillos de pizarra profunda",
  "block.minecraft.deepslate_brick_stairs": "Escaleras de ladrillos de pizarra profunda",
  "block.minecraft.deepslate_brick_wall": "Muro de ladrillos de pizarra profunda",
  "block.minecraft.deepslate_bricks": "Ladrillos de pizarra profunda",
  "block.minecraft.deepslate_coal_ore": "Mena de carbón de pizarra profunda",
  "block.minecraft.deepslate_copper_ore": "Mena de cobre de pizarra profunda",
  "block.minecraft.deepslate_diamond_ore": "Mena de diamante de pizarra profunda",
  "block.minecraft.deepslate_emerald_ore": "Mena de esmeralda de pizarra profunda",
  "block.minecraft.deepslate_gold_ore": "Mena de oro de pizarra profunda",
  "block.minecraft.deepslate_iron_ore": "Mena de hierro de pizarra profunda",
  "block.minecraft.deepslate_lapis_ore": "Mena de lapislázuli de pizarra profunda",
  "block.minecraft.deepslate_redstone_ore": "Mena de redstone de pizarra profunda",
  "block.minecraft.deepslate_tile_slab": "Losa de baldosas de pizarra profunda",
  "block.minecraft.deepslate_tile_stairs": "Escaleras de baldosas de pizarra profunda",
  "block.minecraft.deepslate_tile_wall": "Muro de baldosas de pizarra profunda",
  "block.minecraft.deepslate_tiles": "Baldosas de pizarra profunda",
  "block.minecraft.detector_rail": "Raíl detector",
  "block.minecraft.diamond_block": "Bloque de diamante",
  "block.minecraft.diamond_ore": "Mena de diamante",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Losa de diorita",
  "block.minecraft.diorite_stairs": "Escaleras de diorita",
  "block.minecraft.diorite_wall": "Muro de diorita",
  "block.minecraft.dirt": "Tierra",
  "block.minecraft.dirt_path": "Camino de tierra",
  "block.minecraft.dispenser": "Dispensador",
  "block.minecraft.dragon_egg": "Huevo de dragón",
  "block.minecraft.dragon_head": "Cabeza de dragón",
  "block.minecraft.dragon_wall_head": "Cabeza de dragón en pared",
  "block.minecraft.dried_ghast": "Ghast seco",
  "block.minecraft.dried_kelp_block": "Bloque de algas secas",
  "block.minecraft.dripstone_block": "Bloque de caliza",
  "block.minecraft.dropper": "Soltador",
  "block.minecraft.emerald_block": "Bloque de esmeralda",
  "block.minecraft.emerald_ore": "Mena de esmeralda",
  "block.minecraft.enchanting_table": "Mesa de encantamientos",
  "block.minecraft.end_gateway": "Nexo del End",
  "block.minecraft.end_portal": "Portal del End",
  "block.minecraft.end_portal_frame": "Marco del portal del End",
  "block.minecraft.end_rod": "Vara del End",
  "block.minecraft.end_stone": "Piedra del End",
  "block.minecraft.end_stone_brick_slab": "Losa de ladrillos de piedra del End",
  "block.minecraft.end_stone_brick_stairs": "Escaleras de ladrillos de piedra del End",
  "block.minecraft.end_stone_brick_wall": "Muro de ladrillos de piedra del End",
  "block.minecraft.end_stone_bricks": "Ladrillos de piedra del End",
  "block.minecraft.ender_chest": "Cofre de ender",
  "block.minecraft.exposed_chiseled_copper": "Cobre cincelado expuesto",
  "block.minecraft.exposed_copper": "Cobre expuesto",
  "block.minecraft.exposed_copper_bars": "Barrotes de cobre expuesto",
  "block.minecraft.exposed_copper_bulb": "Lámpara de cobre expuesto",
  "block.minecraft.exposed_copper_chain": "Cadena de cobre expuesto",
  "block.minecraft.exposed_copper_chest": "Cofre de cobre expuesto",
  "block.minecraft.exposed_copper_door": "Puerta de cobre expuesto",
  "block.minecraft.exposed_copper_golem_statue": "Estatua de gólem de cobre expuesto",
  "block.minecraft.exposed_copper_grate": "Rejilla de cobre expuesto",
  "block.minecraft.exposed_copper_lantern": "Farol de cobre expuesto",
  "block.minecraft.exposed_copper_trapdoor": "Trampilla de cobre expuesto",
  "block.minecraft.exposed_cut_copper": "Cobre cortado expuesto",
  "block.minecraft.exposed_cut_copper_slab": "Losa de cobre cortado expuesto",
  "block.minecraft.exposed_cut_copper_stairs": "Escaleras de cobre cortado expuesto",
  "block.minecraft.exposed_lightning_rod": "Pararrayos expuesto",
  "block.minecraft.farmland": "Tierra de cultivo",
  "block.minecraft.fern": "Helecho",
  "block.minecraft.fire": "Fuego",
  "block.minecraft.fire_coral": "Coral de fuego",
  "block.minecraft.fire_coral_block": "Bloque de coral de fuego",
  "block.minecraft.fire_coral_fan": "Gorgonia de fuego",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia de fuego en pared",
  "block.minecraft.firefly_bush": "Arbusto de luciérnagas",
  "block.minecraft.fletching_table": "Mesa de flechas",
  "block.minecraft.flower_pot": "Maceta",
  "block.minecraft.flowering_azalea": "Azalea florecida",
  "block.minecraft.flowering_azalea_leaves": "Hojas de azalea florecida",
  "block.minecraft.frogspawn": "Huevas de rana",
  "block.minecraft.frosted_ice": "Hielo escarchado",
  "block.minecraft.furnace": "Horno",
  "block.minecraft.gilded_blackstone": "Piedra negra áurea",
  "block.minecraft.glass": "Cristal",
  "block.minecraft.glass_pane": "Panel de cristal",
  "block.minecraft.glow_lichen": "Liquen luminoso",
  "block.minecraft.glowstone": "Piedra luminosa",
  "block.minecraft.gold_block": "Bloque de oro",
  "block.minecraft.gold_ore": "Mena de oro",
  "block.minecraft.golden_dandelion": "Diente de león dorado",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Losa de granito",
  "block.minecraft.granite_stairs": "Escaleras de granito",
  "block.minecraft.granite_wall": "Muro de granito",
  "block.minecraft.grass": "Hierba",
  "block.minecraft.grass_block": "Césped",
  "block.minecraft.gravel": "Grava",
  "block.minecraft.gray_banner": "Estandarte gris",
  "block.minecraft.gray_bed": "Cama gris",
  "block.minecraft.gray_candle": "Vela gris",
  "block.minecraft.gray_candle_cake": "Tarta con vela gris",
  "block.minecraft.gray_carpet": "Alfombra gris",
  "block.minecraft.gray_concrete": "Hormigón gris",
  "block.minecraft.gray_concrete_powder": "Cemento gris",
  "block.minecraft.gray_glazed_terracotta": "Azulejo gris",
  "block.minecraft.gray_shulker_box": "Caja de shulker gris",
  "block.minecraft.gray_stained_glass": "Cristal tintado de gris",
  "block.minecraft.gray_stained_glass_pane": "Panel de cristal tintado de gris",
  "block.minecraft.gray_terracotta": "Terracota gris",
  "block.minecraft.gray_wool": "Lana gris",
  "block.minecraft.green_banner": "Estandarte verde",
  "block.minecraft.green_bed": "Cama verde",
  "block.minecraft.green_candle": "Vela verde",
  "block.minecraft.green_candle_cake": "Tarta con vela verde",
  "block.minecraft.green_carpet": "Alfombra verde",
  "block.minecraft.green_concrete": "Hormigón verde",
  "block.minecraft.green_concrete_powder": "Cemento verde",
  "block.minecraft.green_glazed_terracotta": "Azulejo verde",
  "block.minecraft.green_shulker_box": "Caja de shulker verde",
  "block.minecraft.green_stained_glass": "Cristal tintado de verde",
  "block.minecraft.green_stained_glass_pane": "Panel de cristal tintado de verde",
  "block.minecraft.green_terracotta": "Terracota verde",
  "block.minecraft.green_wool": "Lana verde",
  "block.minecraft.grindstone": "Afiladora",
  "block.minecraft.hanging_roots": "Raíces colgantes",
  "block.minecraft.hay_block": "Bala de heno",
  "block.minecraft.heavy_core": "Núcleo pesado",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de presión para peso elevado",
  "block.minecraft.honey_block": "Bloque de miel",
  "block.minecraft.honeycomb_block": "Bloque de panal",
  "block.minecraft.hopper": "Tolva",
  "block.minecraft.horn_coral": "Coral de cuerno",
  "block.minecraft.horn_coral_block": "Bloque de coral de cuerno",
  "block.minecraft.horn_coral_fan": "Gorgonia de cuerno",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia de cuerno en pared",
  "block.minecraft.ice": "Hielo",
  "block.minecraft.infested_chiseled_stone_bricks": "Ladrillos de piedra cincelados infestados",
  "block.minecraft.infested_cobblestone": "Roca infestada",
  "block.minecraft.infested_cracked_stone_bricks": "Ladrillos de piedra agrietados infestados",
  "block.minecraft.infested_deepslate": "Pizarra profunda infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Ladrillos de piedra musgosos infestados",
  "block.minecraft.infested_stone": "Piedra infestada",
  "block.minecraft.infested_stone_bricks": "Ladrillos de piedra infestados",
  "block.minecraft.iron_bars": "Barrotes de hierro",
  "block.minecraft.iron_block": "Bloque de hierro",
  "block.minecraft.iron_chain": "Cadena de hierro",
  "block.minecraft.iron_door": "Puerta de hierro",
  "block.minecraft.iron_ore": "Mena de hierro",
  "block.minecraft.iron_trapdoor": "Trampilla de hierro",
  "block.minecraft.jack_o_lantern": "Calabaza de Halloween",
  "block.minecraft.jigsaw": "Bloque rompecabezas",
  "block.minecraft.jukebox": "Tocadiscos",
  "block.minecraft.jungle_button": "Botón de jungla",
  "block.minecraft.jungle_door": "Puerta de jungla",
  "block.minecraft.jungle_fence": "Valla de jungla",
  "block.minecraft.jungle_fence_gate": "Puerta de valla de jungla",
  "block.minecraft.jungle_hanging_sign": "Cartel colgante de jungla",
  "block.minecraft.jungle_leaves": "Hojas de jungla",
  "block.minecraft.jungle_log": "Tronco de jungla",
  "block.minecraft.jungle_planks": "Tablones de jungla",
  "block.minecraft.jungle_pressure_plate": "Placa de presión de jungla",
  "block.minecraft.jungle_sapling": "Brote de jungla",
  "block.minecraft.jungle_shelf": "Estante de jungla",
  "block.minecraft.jungle_sign": "Cartel de jungla",
  "block.minecraft.jungle_slab": "Losa de jungla",
  "block.minecraft.jungle_stairs": "Escaleras de jungla",
  "block.minecraft.jungle_trapdoor": "Trampilla de jungla",
  "block.minecraft.jungle_wall_hanging_sign": "Cartel colgante de jungla en pared",
  "block.minecraft.jungle_wall_sign": "Cartel de jungla en pared",
  "block.minecraft.jungle_wood": "Leño de jungla",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Tallo de alga",
  "block.minecraft.ladder": "Escalera de mano",
  "block.minecraft.lantern": "Farol",
  "block.minecraft.lapis_block": "Bloque de lapislázuli",
  "block.minecraft.lapis_ore": "Mena de lapislázuli",
  "block.minecraft.large_amethyst_bud": "Brote de amatista grande",
  "block.minecraft.large_fern": "Helecho grande",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Caldero con lava",
  "block.minecraft.leaf_litter": "Hojas secas",
  "block.minecraft.lectern": "Atril",
  "block.minecraft.lever": "Palanca",
  "block.minecraft.light": "Luz",
  "block.minecraft.light_blue_banner": "Estandarte azul claro",
  "block.minecraft.light_blue_bed": "Cama azul claro",
  "block.minecraft.light_blue_candle": "Vela azul claro",
  "block.minecraft.light_blue_candle_cake": "Tarta con vela azul claro",
  "block.minecraft.light_blue_carpet": "Alfombra azul claro",
  "block.minecraft.light_blue_concrete": "Hormigón azul claro",
  "block.minecraft.light_blue_concrete_powder": "Cemento azul claro",
  "block.minecraft.light_blue_glazed_terracotta": "Azulejo azul claro",
  "block.minecraft.light_blue_shulker_box": "Caja de shulker azul claro",
  "block.minecraft.light_blue_stained_glass": "Cristal tintado de azul claro",
  "block.minecraft.light_blue_stained_glass_pane": "Panel de cristal tintado de azul claro",
  "block.minecraft.light_blue_terracotta": "Terracota azul claro",
  "block.minecraft.light_blue_wool": "Lana azul claro",
  "block.minecraft.light_gray_banner": "Estandarte gris claro",
  "block.minecraft.light_gray_bed": "Cama gris claro",
  "block.minecraft.light_gray_candle": "Vela gris claro",
  "block.minecraft.light_gray_candle_cake": "Tarta con vela gris claro",
  "block.minecraft.light_gray_carpet": "Alfombra gris claro",
  "block.minecraft.light_gray_concrete": "Hormigón gris claro",
  "block.minecraft.light_gray_concrete_powder": "Cemento gris claro",
  "block.minecraft.light_gray_glazed_terracotta": "Azulejo gris claro",
  "block.minecraft.light_gray_shulker_box": "Caja de shulker gris claro",
  "block.minecraft.light_gray_stained_glass": "Cristal tintado de gris claro",
  "block.minecraft.light_gray_stained_glass_pane": "Panel de cristal tintado de gris claro",
  "block.minecraft.light_gray_terracotta": "Terracota gris claro",
  "block.minecraft.light_gray_wool": "Lana gris claro",
  "block.minecraft.light_weighted_pressure_plate": "Placa de presión para peso ligero",
  "block.minecraft.lightning_rod": "Pararrayos",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Convalaria",
  "block.minecraft.lily_pad": "Nenúfar",
  "block.minecraft.lime_banner": "Estandarte verde lima",
  "block.minecraft.lime_bed": "Cama verde lima",
  "block.minecraft.lime_candle": "Vela verde lima",
  "block.minecraft.lime_candle_cake": "Tarta con vela verde lima",
  "block.minecraft.lime_carpet": "Alfombra verde lima",
  "block.minecraft.lime_concrete": "Hormigón verde lima",
  "block.minecraft.lime_concrete_powder": "Cemento verde lima",
  "block.minecraft.lime_glazed_terracotta": "Azulejo verde lima",
  "block.minecraft.lime_shulker_box": "Caja de shulker verde lima",
  "block.minecraft.lime_stained_glass": "Cristal tintado de verde lima",
  "block.minecraft.lime_stained_glass_pane": "Panel de cristal tintado de verde lima",
  "block.minecraft.lime_terracotta": "Terracota verde lima",
  "block.minecraft.lime_wool": "Lana lima",
  "block.minecraft.lodestone": "Magnetita",
  "block.minecraft.loom": "Telar",
  "block.minecraft.magenta_banner": "Estandarte magenta",
  "block.minecraft.magenta_bed": "Cama magenta",
  "block.minecraft.magenta_candle": "Vela magenta",
  "block.minecraft.magenta_candle_cake": "Tarta con vela magenta",
  "block.minecraft.magenta_carpet": "Alfombra magenta",
  "block.minecraft.magenta_concrete": "Hormigón magenta",
  "block.minecraft.magenta_concrete_powder": "Cemento magenta",
  "block.minecraft.magenta_glazed_terracotta": "Azulejo magenta",
  "block.minecraft.magenta_shulker_box": "Caja de shulker magenta",
  "block.minecraft.magenta_stained_glass": "Cristal tintado de magenta",
  "block.minecraft.magenta_stained_glass_pane": "Panel de cristal tintado de magenta",
  "block.minecraft.magenta_terracotta": "Terracota magenta",
  "block.minecraft.magenta_wool": "Lana magenta",
  "block.minecraft.magma_block": "Bloque de magma",
  "block.minecraft.mangrove_button": "Botón de mangle",
  "block.minecraft.mangrove_door": "Puerta de mangle",
  "block.minecraft.mangrove_fence": "Valla de mangle",
  "block.minecraft.mangrove_fence_gate": "Puerta de valla de mangle",
  "block.minecraft.mangrove_hanging_sign": "Cartel colgante de mangle",
  "block.minecraft.mangrove_leaves": "Hojas de mangle",
  "block.minecraft.mangrove_log": "Tronco de mangle",
  "block.minecraft.mangrove_planks": "Tablones de mangle",
  "block.minecraft.mangrove_pressure_plate": "Placa de presión de mangle",
  "block.minecraft.mangrove_propagule": "Propágulo de mangle",
  "block.minecraft.mangrove_roots": "Raíces de mangle",
  "block.minecraft.mangrove_shelf": "Estante de mangle",
  "block.minecraft.mangrove_sign": "Cartel de mangle",
  "block.minecraft.mangrove_slab": "Losa de mangle",
  "block.minecraft.mangrove_stairs": "Escaleras de mangle",
  "block.minecraft.mangrove_trapdoor": "Trampilla de mangle",
  "block.minecraft.mangrove_wall_hanging_sign": "Cartel colgante de mangle en pared",
  "block.minecraft.mangrove_wall_sign": "Cartel de mangle en pared",
  "block.minecraft.mangrove_wood": "Leño de mangle",
  "block.minecraft.medium_amethyst_bud": "Brote de amatista mediano",
  "block.minecraft.melon": "Sandía",
  "block.minecraft.melon_stem": "Tallo de sandía",
  "block.minecraft.moss_block": "Bloque de musgo",
  "block.minecraft.moss_carpet": "Capa de musgo",
  "block.minecraft.mossy_cobblestone": "Roca musgosa",
  "block.minecraft.mossy_cobblestone_slab": "Losa de roca musgosa",
  "block.minecraft.mossy_cobblestone_stairs": "Escaleras de roca musgosa",
  "block.minecraft.mossy_cobblestone_wall": "Muro de roca musgosa",
  "block.minecraft.mossy_stone_brick_slab": "Losa de ladrillos de piedra musgosos",
  "block.minecraft.mossy_stone_brick_stairs": "Escaleras de ladrillos de piedra musgosos",
  "block.minecraft.mossy_stone_brick_wall": "Muro de ladrillos de piedra musgosos",
  "block.minecraft.mossy_stone_bricks": "Ladrillos de piedra musgosos",
  "block.minecraft.moving_piston": "Pistón en movimiento",
  "block.minecraft.mud": "Barro",
  "block.minecraft.mud_brick_slab": "Losa de ladrillos de adobe",
  "block.minecraft.mud_brick_stairs": "Escaleras de ladrillos de adobe",
  "block.minecraft.mud_brick_wall": "Muro de ladrillos de adobe",
  "block.minecraft.mud_bricks": "Ladrillos de adobe",
  "block.minecraft.muddy_mangrove_roots": "Raíces de mangle embarradas",
  "block.minecraft.mushroom_stem": "Tallo de champiñón",
  "block.minecraft.mycelium": "Micelio",
  "block.minecraft.nether_brick_fence": "Valla de ladrillos del Nether",
  "block.minecraft.nether_brick_slab": "Losa de ladrillos del Nether",
  "block.minecraft.nether_brick_stairs": "Escaleras de ladrillos del Nether",
  "block.minecraft.nether_brick_wall": "Muro de ladrillos del Nether",
  "block.minecraft.nether_bricks": "Ladrillos del Nether",
  "block.minecraft.nether_gold_ore": "Mena de oro del Nether",
  "block.minecraft.nether_portal": "Portal del Nether",
  "block.minecraft.nether_quartz_ore": "Mena de cuarzo del Nether",
  "block.minecraft.nether_sprouts": "Rastrojo del Nether",
  "block.minecraft.nether_wart": "Verruga del Nether",
  "block.minecraft.nether_wart_block": "Bloque de verrugas del Nether",
  "block.minecraft.netherite_block": "Bloque de netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloque musical",
  "block.minecraft.oak_button": "Botón de roble",
  "block.minecraft.oak_door": "Puerta de roble",
  "block.minecraft.oak_fence": "Valla de roble",
  "block.minecraft.oak_fence_gate": "Puerta de valla de roble",
  "block.minecraft.oak_hanging_sign": "Cartel colgante de roble",
  "block.minecraft.oak_leaves": "Hojas de roble",
  "block.minecraft.oak_log": "Tronco de roble",
  "block.minecraft.oak_planks": "Tablones de roble",
  "block.minecraft.oak_pressure_plate": "Placa de presión de roble",
  "block.minecraft.oak_sapling": "Brote de roble",
  "block.minecraft.oak_shelf": "Estante de roble",
  "block.minecraft.oak_sign": "Cartel de roble",
  "block.minecraft.oak_slab": "Losa de roble",
  "block.minecraft.oak_stairs": "Escaleras de roble",
  "block.minecraft.oak_trapdoor": "Trampilla de roble",
  "block.minecraft.oak_wall_hanging_sign": "Cartel colgante de roble en pared",
  "block.minecraft.oak_wall_sign": "Cartel de roble en pared",
  "block.minecraft.oak_wood": "Leño de roble",
  "block.minecraft.observer": "Observador",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Ranaluz ocre",
  "block.minecraft.ominous_banner": "Estandarte ominoso",
  "block.minecraft.open_eyeblossom": "Miraflor abierta",
  "block.minecraft.orange_banner": "Estandarte naranja",
  "block.minecraft.orange_bed": "Cama naranja",
  "block.minecraft.orange_candle": "Vela naranja",
  "block.minecraft.orange_candle_cake": "Tarta con vela naranja",
  "block.minecraft.orange_carpet": "Alfombra naranja",
  "block.minecraft.orange_concrete": "Hormigón naranja",
  "block.minecraft.orange_concrete_powder": "Cemento naranja",
  "block.minecraft.orange_glazed_terracotta": "Azulejo naranja",
  "block.minecraft.orange_shulker_box": "Caja de shulker naranja",
  "block.minecraft.orange_stained_glass": "Cristal tintado de naranja",
  "block.minecraft.orange_stained_glass_pane": "Panel de cristal tintado de naranja",
  "block.minecraft.orange_terracotta": "Terracota naranja",
  "block.minecraft.orange_tulip": "Tulipán naranja",
  "block.minecraft.orange_wool": "Lana naranja",
  "block.minecraft.oxeye_daisy": "Margarita",
  "block.minecraft.oxidized_chiseled_copper": "Cobre cincelado oxidado",
  "block.minecraft.oxidized_copper": "Cobre oxidado",
  "block.minecraft.oxidized_copper_bars": "Barrotes de cobre oxidado",
  "block.minecraft.oxidized_copper_bulb": "Lámpara de cobre oxidado",
  "block.minecraft.oxidized_copper_chain": "Cadena de cobre oxidado",
  "block.minecraft.oxidized_copper_chest": "Cofre de cobre oxidado",
  "block.minecraft.oxidized_copper_door": "Puerta de cobre oxidado",
  "block.minecraft.oxidized_copper_golem_statue": "Estatua de gólem de cobre oxidado",
  "block.minecraft.oxidized_copper_grate": "Rejilla de cobre oxidado",
  "block.minecraft.oxidized_copper_lantern": "Farol de cobre oxidado",
  "block.minecraft.oxidized_copper_trapdoor": "Trampilla de cobre oxidado",
  "block.minecraft.oxidized_cut_copper": "Cobre cortado oxidado",
  "block.minecraft.oxidized_cut_copper_slab": "Losa de cobre cortado oxidado",
  "block.minecraft.oxidized_cut_copper_stairs": "Escaleras de cobre cortado oxidado",
  "block.minecraft.oxidized_lightning_rod": "Pararrayos oxidado",
  "block.minecraft.packed_ice": "Hielo compacto",
  "block.minecraft.packed_mud": "Adobe",
  "block.minecraft.pale_hanging_moss": "Musgo pálido colgante",
  "block.minecraft.pale_moss_block": "Bloque de musgo pálido",
  "block.minecraft.pale_moss_carpet": "Capa de musgo pálido",
  "block.minecraft.pale_oak_button": "Botón de roble pálido",
  "block.minecraft.pale_oak_door": "Puerta de roble pálido",
  "block.minecraft.pale_oak_fence": "Valla de roble pálido",
  "block.minecraft.pale_oak_fence_gate": "Puerta de valla de roble pálido",
  "block.minecraft.pale_oak_hanging_sign": "Cartel colgante de roble pálido",
  "block.minecraft.pale_oak_leaves": "Hojas de roble pálido",
  "block.minecraft.pale_oak_log": "Tronco de roble pálido",
  "block.minecraft.pale_oak_planks": "Tablones de roble pálido",
  "block.minecraft.pale_oak_pressure_plate": "Placa de presión de roble pálido",
  "block.minecraft.pale_oak_sapling": "Brote de roble pálido",
  "block.minecraft.pale_oak_shelf": "Estante de roble pálido",
  "block.minecraft.pale_oak_sign": "Cartel de roble pálido",
  "block.minecraft.pale_oak_slab": "Losa de roble pálido",
  "block.minecraft.pale_oak_stairs": "Escaleras de roble pálido",
  "block.minecraft.pale_oak_trapdoor": "Trampilla de roble pálido",
  "block.minecraft.pale_oak_wall_hanging_sign": "Cartel colgante de roble pálido en pared",
  "block.minecraft.pale_oak_wall_sign": "Cartel de roble pálido en pared",
  "block.minecraft.pale_oak_wood": "Leño de roble pálido",
  "block.minecraft.pearlescent_froglight": "Ranaluz nacarada",
  "block.minecraft.peony": "Peonía",
  "block.minecraft.petrified_oak_slab": "Losa de roble petrificada",
  "block.minecraft.piglin_head": "Cabeza de piglin",
  "block.minecraft.piglin_wall_head": "Cabeza de piglin en pared",
  "block.minecraft.pink_banner": "Estandarte rosa",
  "block.minecraft.pink_bed": "Cama rosa",
  "block.minecraft.pink_candle": "Vela rosa",
  "block.minecraft.pink_candle_cake": "Tarta con vela rosa",
  "block.minecraft.pink_carpet": "Alfombra rosa",
  "block.minecraft.pink_concrete": "Hormigón rosa",
  "block.minecraft.pink_concrete_powder": "Cemento rosa",
  "block.minecraft.pink_glazed_terracotta": "Azulejo rosa",
  "block.minecraft.pink_petals": "Pétalos rosas",
  "block.minecraft.pink_shulker_box": "Caja de shulker rosa",
  "block.minecraft.pink_stained_glass": "Cristal tintado de rosa",
  "block.minecraft.pink_stained_glass_pane": "Panel de cristal tintado de rosa",
  "block.minecraft.pink_terracotta": "Terracota rosa",
  "block.minecraft.pink_tulip": "Tulipán rosa",
  "block.minecraft.pink_wool": "Lana rosa",
  "block.minecraft.piston": "Pistón",
  "block.minecraft.piston_head": "Cabeza de pistón",
  "block.minecraft.pitcher_crop": "Cultivo de planta odre",
  "block.minecraft.pitcher_plant": "Planta odre",
  "block.minecraft.player_head": "Cabeza de jugador",
  "block.minecraft.player_head.named": "Cabeza de %s",
  "block.minecraft.player_wall_head": "Cabeza de jugador en pared",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Caliza puntiaguda",
  "block.minecraft.polished_andesite": "Andesita pulida",
  "block.minecraft.polished_andesite_slab": "Losa de andesita pulida",
  "block.minecraft.polished_andesite_stairs": "Escaleras de andesita pulida",
  "block.minecraft.polished_basalt": "Basalto pulido",
  "block.minecraft.polished_blackstone": "Piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_slab": "Losa de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_stairs": "Escaleras de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_wall": "Muro de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_bricks": "Ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_button": "Botón de piedra negra pulida",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de presión de piedra negra pulida",
  "block.minecraft.polished_blackstone_slab": "Losa de piedra negra pulida",
  "block.minecraft.polished_blackstone_stairs": "Escaleras de piedra negra pulida",
  "block.minecraft.polished_blackstone_wall": "Muro de piedra negra pulida",
  "block.minecraft.polished_deepslate": "Pizarra profunda pulida",
  "block.minecraft.polished_deepslate_slab": "Losa de pizarra profunda pulida",
  "block.minecraft.polished_deepslate_stairs": "Escaleras de pizarra profunda pulida",
  "block.minecraft.polished_deepslate_wall": "Muro de pizarra profunda pulida",
  "block.minecraft.polished_diorite": "Diorita pulida",
  "block.minecraft.polished_diorite_slab": "Losa de diorita pulida",
  "block.minecraft.polished_diorite_stairs": "Escaleras de diorita pulida",
  "block.minecraft.polished_granite": "Granito pulido",
  "block.minecraft.polished_granite_slab": "Losa de granito pulido",
  "block.minecraft.polished_granite_stairs": "Escaleras de granito pulido",
  "block.minecraft.polished_tuff": "Toba pulida",
  "block.minecraft.polished_tuff_slab": "Losa de toba pulida",
  "block.minecraft.polished_tuff_stairs": "Escaleras de toba pulida",
  "block.minecraft.polished_tuff_wall": "Muro de toba pulida",
  "block.minecraft.poppy": "Amapola",
  "block.minecraft.potatoes": "Patatas",
  "block.minecraft.potted_acacia_sapling": "Maceta con brote de acacia",
  "block.minecraft.potted_allium": "Maceta con allium",
  "block.minecraft.potted_azalea_bush": "Maceta con azalea",
  "block.minecraft.potted_azure_bluet": "Maceta con azure bluet",
  "block.minecraft.potted_bamboo": "Maceta con bambú",
  "block.minecraft.potted_birch_sapling": "Maceta con brote de abedul",
  "block.minecraft.potted_blue_orchid": "Maceta con orquídea azul",
  "block.minecraft.potted_brown_mushroom": "Maceta con champiñón marrón",
  "block.minecraft.potted_cactus": "Maceta con cactus",
  "block.minecraft.potted_cherry_sapling": "Maceta con brote de cerezo",
  "block.minecraft.potted_closed_eyeblossom": "Maceta con miraflor cerrada",
  "block.minecraft.potted_cornflower": "Maceta con aciano",
  "block.minecraft.potted_crimson_fungus": "Maceta con hongo carmesí",
  "block.minecraft.potted_crimson_roots": "Maceta con raíces carmesí",
  "block.minecraft.potted_dandelion": "Maceta con diente de león",
  "block.minecraft.potted_dark_oak_sapling": "Maceta con brote de roble oscuro",
  "block.minecraft.potted_dead_bush": "Maceta con arbusto muerto",
  "block.minecraft.potted_fern": "Maceta con helecho",
  "block.minecraft.potted_flowering_azalea_bush": "Maceta con azalea florecida",
  "block.minecraft.potted_golden_dandelion": "Maceta con diente de león dorado",
  "block.minecraft.potted_jungle_sapling": "Maceta con brote de jungla",
  "block.minecraft.potted_lily_of_the_valley": "Maceta con convalaria",
  "block.minecraft.potted_mangrove_propagule": "Maceta con propágulo de mangle",
  "block.minecraft.potted_oak_sapling": "Maceta con brote de roble",
  "block.minecraft.potted_open_eyeblossom": "Maceta con miraflor abierta",
  "block.minecraft.potted_orange_tulip": "Maceta con tulipán naranja",
  "block.minecraft.potted_oxeye_daisy": "Maceta con margarita",
  "block.minecraft.potted_pale_oak_sapling": "Maceta con brote de roble pálido",
  "block.minecraft.potted_pink_tulip": "Maceta con tulipán rosa",
  "block.minecraft.potted_poppy": "Maceta con amapola",
  "block.minecraft.potted_red_mushroom": "Maceta con champiñón rojo",
  "block.minecraft.potted_red_tulip": "Maceta con tulipán rojo",
  "block.minecraft.potted_spruce_sapling": "Maceta con brote de abeto",
  "block.minecraft.potted_torchflower": "Maceta con plantorcha",
  "block.minecraft.potted_warped_fungus": "Maceta con hongo distorsionado",
  "block.minecraft.potted_warped_roots": "Maceta con raíces distorsionadas",
  "block.minecraft.potted_white_tulip": "Maceta con tulipán blanco",
  "block.minecraft.potted_wither_rose": "Maceta con rosa del Wither",
  "block.minecraft.powder_snow": "Nieve polvo",
  "block.minecraft.powder_snow_cauldron": "Caldero con nieve polvo",
  "block.minecraft.powered_rail": "Raíl propulsor",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Losa de ladrillos de prismarina",
  "block.minecraft.prismarine_brick_stairs": "Escaleras de ladrillos de prismarina",
  "block.minecraft.prismarine_bricks": "Ladrillos de prismarina",
  "block.minecraft.prismarine_slab": "Losa de prismarina",
  "block.minecraft.prismarine_stairs": "Escaleras de prismarina",
  "block.minecraft.prismarine_wall": "Muro de prismarina",
  "block.minecraft.pumpkin": "Calabaza",
  "block.minecraft.pumpkin_stem": "Tallo de calabaza",
  "block.minecraft.purple_banner": "Estandarte morado",
  "block.minecraft.purple_bed": "Cama morada",
  "block.minecraft.purple_candle": "Vela morada",
  "block.minecraft.purple_candle_cake": "Tarta con vela morada",
  "block.minecraft.purple_carpet": "Alfombra morada",
  "block.minecraft.purple_concrete": "Hormigón morado",
  "block.minecraft.purple_concrete_powder": "Cemento morado",
  "block.minecraft.purple_glazed_terracotta": "Azulejo morado",
  "block.minecraft.purple_shulker_box": "Caja de shulker morada",
  "block.minecraft.purple_stained_glass": "Cristal tintado de morado",
  "block.minecraft.purple_stained_glass_pane": "Panel de cristal tintado de morado",
  "block.minecraft.purple_terracotta": "Terracota morada",
  "block.minecraft.purple_wool": "Lana morada",
  "block.minecraft.purpur_block": "Bloque de purpur",
  "block.minecraft.purpur_pillar": "Pilar de purpur",
  "block.minecraft.purpur_slab": "Losa de purpur",
  "block.minecraft.purpur_stairs": "Escaleras de purpur",
  "block.minecraft.quartz_block": "Cuarzo",
  "block.minecraft.quartz_bricks": "Ladrillos de cuarzo",
  "block.minecraft.quartz_pillar": "Pilar de cuarzo",
  "block.minecraft.quartz_slab": "Losa de cuarzo",
  "block.minecraft.quartz_stairs": "Escaleras de cuarzo",
  "block.minecraft.rail": "Raíl",
  "block.minecraft.raw_copper_block": "Bloque de cobre en bruto",
  "block.minecraft.raw_gold_block": "Bloque de oro en bruto",
  "block.minecraft.raw_iron_block": "Bloque de hierro en bruto",
  "block.minecraft.red_banner": "Estandarte rojo",
  "block.minecraft.red_bed": "Cama roja",
  "block.minecraft.red_candle": "Vela roja",
  "block.minecraft.red_candle_cake": "Tarta con vela roja",
  "block.minecraft.red_carpet": "Alfombra roja",
  "block.minecraft.red_concrete": "Hormigón rojo",
  "block.minecraft.red_concrete_powder": "Cemento rojo",
  "block.minecraft.red_glazed_terracotta": "Azulejo rojo",
  "block.minecraft.red_mushroom": "Champiñón rojo",
  "block.minecraft.red_mushroom_block": "Bloque de champiñón rojo",
  "block.minecraft.red_nether_brick_slab": "Losa de ladrillos del Nether rojos",
  "block.minecraft.red_nether_brick_stairs": "Escaleras de ladrillos del Nether rojos",
  "block.minecraft.red_nether_brick_wall": "Muro de ladrillos del Nether rojos",
  "block.minecraft.red_nether_bricks": "Ladrillos del Nether rojos",
  "block.minecraft.red_sand": "Arena roja",
  "block.minecraft.red_sandstone": "Arenisca roja",
  "block.minecraft.red_sandstone_slab": "Losa de arenisca roja",
  "block.minecraft.red_sandstone_stairs": "Escaleras de arenisca roja",
  "block.minecraft.red_sandstone_wall": "Muro de arenisca roja",
  "block.minecraft.red_shulker_box": "Caja de shulker roja",
  "block.minecraft.red_stained_glass": "Cristal tintado de rojo",
  "block.minecraft.red_stained_glass_pane": "Panel de cristal tintado de rojo",
  "block.minecraft.red_terracotta": "Terracota roja",
  "block.minecraft.red_tulip": "Tulipán rojo",
  "block.minecraft.red_wool": "Lana roja",
  "block.minecraft.redstone_block": "Bloque de redstone",
  "block.minecraft.redstone_lamp": "Lámpara de redstone",
  "block.minecraft.redstone_ore": "Mena de redstone",
  "block.minecraft.redstone_torch": "Antorcha de redstone",
  "block.minecraft.redstone_wall_torch": "Antorcha de redstone en pared",
  "block.minecraft.redstone_wire": "Cable de redstone",
  "block.minecraft.reinforced_deepslate": "Pizarra profunda reforzada",
  "block.minecraft.repeater": "Repetidor de redstone",
  "block.minecraft.repeating_command_block": "Bloque de comando de repetición",
  "block.minecraft.resin_block": "Bloque de resina",
  "block.minecraft.resin_brick_slab": "Losa de ladrillos de resina",
  "block.minecraft.resin_brick_stairs": "Escaleras de ladrillos de resina",
  "block.minecraft.resin_brick_wall": "Muro de ladrillos de resina",
  "block.minecraft.resin_bricks": "Ladrillos de resina",
  "block.minecraft.resin_clump": "Grumo de resina",
  "block.minecraft.respawn_anchor": "Nexo de reaparición",
  "block.minecraft.rooted_dirt": "Tierra enraizada",
  "block.minecraft.rose_bush": "Rosal",
  "block.minecraft.sand": "Arena",
  "block.minecraft.sandstone": "Arenisca",
  "block.minecraft.sandstone_slab": "Losa de arenisca",
  "block.minecraft.sandstone_stairs": "Escaleras de arenisca",
  "block.minecraft.sandstone_wall": "Muro de arenisca",
  "block.minecraft.scaffolding": "Andamio",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizador de sculk",
  "block.minecraft.sculk_sensor": "Sensor de sculk",
  "block.minecraft.sculk_shrieker": "Chillador de sculk",
  "block.minecraft.sculk_vein": "Vena de sculk",
  "block.minecraft.sea_lantern": "Linterna marina",
  "block.minecraft.sea_pickle": "Pepino de mar",
  "block.minecraft.seagrass": "Hierba marina",
  "block.minecraft.set_spawn": "Se ha establecido el punto de reaparición",
  "block.minecraft.short_dry_grass": "Hierba seca corta",
  "block.minecraft.short_grass": "Hierba corta",
  "block.minecraft.shroomlight": "Brillongo",
  "block.minecraft.shulker_box": "Caja de shulker",
  "block.minecraft.skeleton_skull": "Calavera de esqueleto",
  "block.minecraft.skeleton_wall_skull": "Calavera de esqueleto en pared",
  "block.minecraft.slime_block": "Bloque de slime",
  "block.minecraft.small_amethyst_bud": "Brote de amatista pequeño",
  "block.minecraft.small_dripleaf": "Plantaforma pequeña",
  "block.minecraft.smithing_table": "Mesa de herrería",
  "block.minecraft.smoker": "Ahumador",
  "block.minecraft.smooth_basalt": "Basalto liso",
  "block.minecraft.smooth_quartz": "Bloque de cuarzo liso",
  "block.minecraft.smooth_quartz_slab": "Losa de cuarzo liso",
  "block.minecraft.smooth_quartz_stairs": "Escaleras de cuarzo liso",
  "block.minecraft.smooth_red_sandstone": "Arenisca roja lisa",
  "block.minecraft.smooth_red_sandstone_slab": "Losa de arenisca roja lisa",
  "block.minecraft.smooth_red_sandstone_stairs": "Escaleras de arenisca roja lisa",
  "block.minecraft.smooth_sandstone": "Arenisca lisa",
  "block.minecraft.smooth_sandstone_slab": "Losa de arenisca lisa",
  "block.minecraft.smooth_sandstone_stairs": "Escaleras de arenisca lisa",
  "block.minecraft.smooth_stone": "Piedra lisa",
  "block.minecraft.smooth_stone_slab": "Losa de piedra lisa",
  "block.minecraft.sniffer_egg": "Huevo de sniffer",
  "block.minecraft.snow": "Capa de nieve",
  "block.minecraft.snow_block": "Bloque de nieve",
  "block.minecraft.soul_campfire": "Hoguera de almas",
  "block.minecraft.soul_fire": "Fuego de almas",
  "block.minecraft.soul_lantern": "Farol de almas",
  "block.minecraft.soul_sand": "Arena de almas",
  "block.minecraft.soul_soil": "Tierra de almas",
  "block.minecraft.soul_torch": "Antorcha de almas",
  "block.minecraft.soul_wall_torch": "Antorcha de almas en pared",
  "block.minecraft.spawn.not_valid": "No tienes una cama o nexo de reaparición cargado, o pueden estar obstruidos",
  "block.minecraft.spawner": "Generador de criaturas",
  "block.minecraft.spawner.desc1": "Interactúa con un huevo generador:",
  "block.minecraft.spawner.desc2": "Establece el tipo de criatura",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Flor de esporas",
  "block.minecraft.spruce_button": "Botón de abeto",
  "block.minecraft.spruce_door": "Puerta de abeto",
  "block.minecraft.spruce_fence": "Valla de abeto",
  "block.minecraft.spruce_fence_gate": "Puerta de valla de abeto",
  "block.minecraft.spruce_hanging_sign": "Cartel colgante de abeto",
  "block.minecraft.spruce_leaves": "Hojas de abeto",
  "block.minecraft.spruce_log": "Tronco de abeto",
  "block.minecraft.spruce_planks": "Tablones de abeto",
  "block.minecraft.spruce_pressure_plate": "Placa de presión de abeto",
  "block.minecraft.spruce_sapling": "Brote de abeto",
  "block.minecraft.spruce_shelf": "Estante de abeto",
  "block.minecraft.spruce_sign": "Cartel de abeto",
  "block.minecraft.spruce_slab": "Losa de abeto",
  "block.minecraft.spruce_stairs": "Escaleras de abeto",
  "block.minecraft.spruce_trapdoor": "Trampilla de abeto",
  "block.minecraft.spruce_wall_hanging_sign": "Cartel colgante de abeto en pared",
  "block.minecraft.spruce_wall_sign": "Cartel de abeto en pared",
  "block.minecraft.spruce_wood": "Leño de abeto",
  "block.minecraft.sticky_piston": "Pistón pegajoso",
  "block.minecraft.stone": "Piedra",
  "block.minecraft.stone_brick_slab": "Losa de ladrillos de piedra",
  "block.minecraft.stone_brick_stairs": "Escaleras de ladrillos de piedra",
  "block.minecraft.stone_brick_wall": "Muro de ladrillos de piedra",
  "block.minecraft.stone_bricks": "Ladrillos de piedra",
  "block.minecraft.stone_button": "Botón de piedra",
  "block.minecraft.stone_pressure_plate": "Placa de presión de piedra",
  "block.minecraft.stone_slab": "Losa de piedra",
  "block.minecraft.stone_stairs": "Escaleras de piedra",
  "block.minecraft.stonecutter": "Cortapiedras",
  "block.minecraft.stripped_acacia_log": "Tronco de acacia sin corteza",
  "block.minecraft.stripped_acacia_wood": "Leño de acacia sin corteza",
  "block.minecraft.stripped_bamboo_block": "Bloque de bambú pelado",
  "block.minecraft.stripped_birch_log": "Tronco de abedul sin corteza",
  "block.minecraft.stripped_birch_wood": "Leño de abedul sin corteza",
  "block.minecraft.stripped_cherry_log": "Tronco de cerezo sin corteza",
  "block.minecraft.stripped_cherry_wood": "Leño de cerezo sin corteza",
  "block.minecraft.stripped_crimson_hyphae": "Hifas carmesí peladas",
  "block.minecraft.stripped_crimson_stem": "Tallo carmesí pelado",
  "block.minecraft.stripped_dark_oak_log": "Tronco de roble oscuro sin corteza",
  "block.minecraft.stripped_dark_oak_wood": "Leño de roble oscuro sin corteza",
  "block.minecraft.stripped_jungle_log": "Tronco de jungla sin corteza",
  "block.minecraft.stripped_jungle_wood": "Leño de jungla sin corteza",
  "block.minecraft.stripped_mangrove_log": "Tronco de mangle sin corteza",
  "block.minecraft.stripped_mangrove_wood": "Leño de mangle sin corteza",
  "block.minecraft.stripped_oak_log": "Tronco de roble sin corteza",
  "block.minecraft.stripped_oak_wood": "Leño de roble sin corteza",
  "block.minecraft.stripped_pale_oak_log": "Tronco de roble pálido sin corteza",
  "block.minecraft.stripped_pale_oak_wood": "Leño de roble pálido sin corteza",
  "block.minecraft.stripped_spruce_log": "Tronco de abeto sin corteza",
  "block.minecraft.stripped_spruce_wood": "Leño de abeto sin corteza",
  "block.minecraft.stripped_warped_hyphae": "Hifas distorsionadas peladas",
  "block.minecraft.stripped_warped_stem": "Tallo distorsionado pelado",
  "block.minecraft.structure_block": "Bloque estructural",
  "block.minecraft.structure_void": "Vacío estructural",
  "block.minecraft.sugar_cane": "Caña de azúcar",
  "block.minecraft.sunflower": "Girasol",
  "block.minecraft.suspicious_gravel": "Grava sospechosa",
  "block.minecraft.suspicious_sand": "Arena sospechosa",
  "block.minecraft.sweet_berry_bush": "Arbusto de bayas dulces",
  "block.minecraft.tall_dry_grass": "Hierba seca alta",
  "block.minecraft.tall_grass": "Hierba alta",
  "block.minecraft.tall_seagrass": "Hierba marina alta",
  "block.minecraft.target": "Diana",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloque de pruebas",
  "block.minecraft.test_instance_block": "Bloque de caso de prueba",
  "block.minecraft.tinted_glass": "Cristal opaco",
  "block.minecraft.tnt": "Dinamita",
  "block.minecraft.tnt.disabled": "Las explosiones de dinamita están desactivadas",
  "block.minecraft.torch": "Antorcha",
  "block.minecraft.torchflower": "Plantorcha",
  "block.minecraft.torchflower_crop": "Cultivo de plantorcha",
  "block.minecraft.trapped_chest": "Cofre trampa",
  "block.minecraft.trial_spawner": "Generador de desafío",
  "block.minecraft.tripwire": "Hilo trampa",
  "block.minecraft.tripwire_hook": "Gancho de cuerda",
  "block.minecraft.tube_coral": "Coral de tubo",
  "block.minecraft.tube_coral_block": "Bloque de coral de tubo",
  "block.minecraft.tube_coral_fan": "Gorgonia de tubo",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia de tubo en pared",
  "block.minecraft.tuff": "Toba",
  "block.minecraft.tuff_brick_slab": "Losa de ladrillos de toba",
  "block.minecraft.tuff_brick_stairs": "Escaleras de ladrillos de toba",
  "block.minecraft.tuff_brick_wall": "Muro de ladrillos de toba",
  "block.minecraft.tuff_bricks": "Ladrillos de toba",
  "block.minecraft.tuff_slab": "Losa de toba",
  "block.minecraft.tuff_stairs": "Escaleras de toba",
  "block.minecraft.tuff_wall": "Muro de toba",
  "block.minecraft.turtle_egg": "Huevo de tortuga",
  "block.minecraft.twisting_vines": "Enredaderas retorcidas",
  "block.minecraft.twisting_vines_plant": "Tallo de enredaderas retorcidas",
  "block.minecraft.vault": "Arca",
  "block.minecraft.verdant_froglight": "Ranaluz verde",
  "block.minecraft.vine": "Enredaderas",
  "block.minecraft.void_air": "Aire de vacío",
  "block.minecraft.wall_torch": "Antorcha en pared",
  "block.minecraft.warped_button": "Botón distorsionado",
  "block.minecraft.warped_door": "Puerta distorsionada",
  "block.minecraft.warped_fence": "Valla distorsionada",
  "block.minecraft.warped_fence_gate": "Puerta de valla distorsionada",
  "block.minecraft.warped_fungus": "Hongo distorsionado",
  "block.minecraft.warped_hanging_sign": "Cartel colgante distorsionado",
  "block.minecraft.warped_hyphae": "Hifas distorsionadas",
  "block.minecraft.warped_nylium": "Necelio distorsionado",
  "block.minecraft.warped_planks": "Tablones distorsionados",
  "block.minecraft.warped_pressure_plate": "Placa de presión distorsionada",
  "block.minecraft.warped_roots": "Raíces distorsionadas",
  "block.minecraft.warped_shelf": "Estante distorsionado",
  "block.minecraft.warped_sign": "Cartel distorsionado",
  "block.minecraft.warped_slab": "Losa distorsionada",
  "block.minecraft.warped_stairs": "Escaleras distorsionadas",
  "block.minecraft.warped_stem": "Tallo distorsionado",
  "block.minecraft.warped_trapdoor": "Trampilla distorsionada",
  "block.minecraft.warped_wall_hanging_sign": "Cartel colgante distorsionado en pared",
  "block.minecraft.warped_wall_sign": "Cartel distorsionado en pared",
  "block.minecraft.warped_wart_block": "Bloque de verrugas distorsionadas",
  "block.minecraft.water": "Agua",
  "block.minecraft.water_cauldron": "Caldero con agua",
  "block.minecraft.waxed_chiseled_copper": "Cobre cincelado encerado",
  "block.minecraft.waxed_copper_bars": "Barrotes de cobre encerado",
  "block.minecraft.waxed_copper_block": "Bloque de cobre encerado",
  "block.minecraft.waxed_copper_bulb": "Lámpara de cobre encerado",
  "block.minecraft.waxed_copper_chain": "Cadena de cobre encerado",
  "block.minecraft.waxed_copper_chest": "Cofre de cobre encerado",
  "block.minecraft.waxed_copper_door": "Puerta de cobre encerado",
  "block.minecraft.waxed_copper_golem_statue": "Estatua de gólem de cobre encerado",
  "block.minecraft.waxed_copper_grate": "Rejilla de cobre encerado",
  "block.minecraft.waxed_copper_lantern": "Farol de cobre encerado",
  "block.minecraft.waxed_copper_trapdoor": "Trampilla de cobre encerado",
  "block.minecraft.waxed_cut_copper": "Cobre cortado encerado",
  "block.minecraft.waxed_cut_copper_slab": "Losa de cobre cortado encerado",
  "block.minecraft.waxed_cut_copper_stairs": "Escaleras de cobre cortado encerado",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cobre cincelado expuesto encerado",
  "block.minecraft.waxed_exposed_copper": "Cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_bars": "Barrotes de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_bulb": "Lámpara de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_chain": "Cadena de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_chest": "Cofre de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_door": "Puerta de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estatua de gólem de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_grate": "Rejilla de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_lantern": "Farol de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trampilla de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_cut_copper": "Cobre cortado expuesto encerado",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Losa de cobre cortado expuesto encerado",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escaleras de cobre cortado expuesto encerado",
  "block.minecraft.waxed_exposed_lightning_rod": "Pararrayos expuesto encerado",
  "block.minecraft.waxed_lightning_rod": "Pararrayos encerado",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cobre cincelado oxidado encerado",
  "block.minecraft.waxed_oxidized_copper": "Cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_bars": "Barrotes de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lámpara de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_chain": "Cadena de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_chest": "Cofre de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_door": "Puerta de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estatua de gólem de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_grate": "Rejilla de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_lantern": "Farol de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trampilla de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_cut_copper": "Cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Losa de cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escaleras de cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_lightning_rod": "Pararrayos oxidado encerado",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cobre cincelado degradado encerado",
  "block.minecraft.waxed_weathered_copper": "Cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_bars": "Barrotes de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_bulb": "Lámpara de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_chain": "Cadena de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_chest": "Cofre de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_door": "Puerta de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estatua de gólem de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_grate": "Rejilla de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_lantern": "Farol de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trampilla de cobre degradado encerado",
  "block.minecraft.waxed_weathered_cut_copper": "Cobre cortado degradado encerado",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Losa de cobre cortado degradado encerado",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escaleras de cobre cortado degradado encerado",
  "block.minecraft.waxed_weathered_lightning_rod": "Pararrayos degradado encerado",
  "block.minecraft.weathered_chiseled_copper": "Cobre cincelado degradado",
  "block.minecraft.weathered_copper": "Cobre degradado",
  "block.minecraft.weathered_copper_bars": "Barrotes de cobre degradado",
  "block.minecraft.weathered_copper_bulb": "Lámpara de cobre degradado",
  "block.minecraft.weathered_copper_chain": "Cadena de cobre degradado",
  "block.minecraft.weathered_copper_chest": "Cofre de cobre degradado",
  "block.minecraft.weathered_copper_door": "Puerta de cobre degradado",
  "block.minecraft.weathered_copper_golem_statue": "Estatua de gólem de cobre degradado",
  "block.minecraft.weathered_copper_grate": "Rejilla de cobre degradado",
  "block.minecraft.weathered_copper_lantern": "Farol de cobre degradado",
  "block.minecraft.weathered_copper_trapdoor": "Trampilla de cobre degradado",
  "block.minecraft.weathered_cut_copper": "Cobre cortado degradado",
  "block.minecraft.weathered_cut_copper_slab": "Losa de cobre cortado degradado",
  "block.minecraft.weathered_cut_copper_stairs": "Escaleras de cobre cortado degradado",
  "block.minecraft.weathered_lightning_rod": "Pararrayos degradado",
  "block.minecraft.weeping_vines": "Enredaderas lacrimosas",
  "block.minecraft.weeping_vines_plant": "Tallo de enredaderas lacrimosas",
  "block.minecraft.wet_sponge": "Esponja mojada",
  "block.minecraft.wheat": "Cultivo de trigo",
  "block.minecraft.white_banner": "Estandarte blanco",
  "block.minecraft.white_bed": "Cama blanca",
  "block.minecraft.white_candle": "Vela blanca",
  "block.minecraft.white_candle_cake": "Tarta con vela blanca",
  "block.minecraft.white_carpet": "Alfombra blanca",
  "block.minecraft.white_concrete": "Hormigón blanco",
  "block.minecraft.white_concrete_powder": "Cemento blanco",
  "block.minecraft.white_glazed_terracotta": "Azulejo blanco",
  "block.minecraft.white_shulker_box": "Caja de shulker blanca",
  "block.minecraft.white_stained_glass": "Cristal tintado de blanco",
  "block.minecraft.white_stained_glass_pane": "Panel de cristal tintado de blanco",
  "block.minecraft.white_terracotta": "Terracota blanca",
  "block.minecraft.white_tulip": "Tulipán blanco",
  "block.minecraft.white_wool": "Lana blanca",
  "block.minecraft.wildflowers": "Florecillas silvestres",
  "block.minecraft.wither_rose": "Rosa del Wither",
  "block.minecraft.wither_skeleton_skull": "Calavera de esqueleto del Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Calavera de esqueleto del Wither en pared",
  "block.minecraft.yellow_banner": "Estandarte amarillo",
  "block.minecraft.yellow_bed": "Cama amarilla",
  "block.minecraft.yellow_candle": "Vela amarilla",
  "block.minecraft.yellow_candle_cake": "Tarta con vela amarilla",
  "block.minecraft.yellow_carpet": "Alfombra amarilla",
  "block.minecraft.yellow_concrete": "Hormigón amarillo",
  "block.minecraft.yellow_concrete_powder": "Cemento amarillo",
  "block.minecraft.yellow_glazed_terracotta": "Azulejo amarillo",
  "block.minecraft.yellow_shulker_box": "Caja de shulker amarilla",
  "block.minecraft.yellow_stained_glass": "Cristal tintado de amarillo",
  "block.minecraft.yellow_stained_glass_pane": "Panel de cristal tintado de amarillo",
  "block.minecraft.yellow_terracotta": "Terracota amarilla",
  "block.minecraft.yellow_wool": "Lana amarilla",
  "block.minecraft.zombie_head": "Cabeza de zombi",
  "block.minecraft.zombie_wall_head": "Cabeza de zombi en pared",
  "item.minecraft.acacia_boat": "Barca de acacia",
  "item.minecraft.acacia_chest_boat": "Barca de acacia con cofre",
  "item.minecraft.allay_spawn_egg": "Generar allay",
  "item.minecraft.amethyst_shard": "Fragmento de amatista",
  "item.minecraft.angler_pottery_shard": "Fragmento de cerámica de caña de pescar",
  "item.minecraft.angler_pottery_sherd": "Fragmento de cerámica de caña de pescar",
  "item.minecraft.apple": "Manzana",
  "item.minecraft.archer_pottery_shard": "Fragmento de cerámica de arco",
  "item.minecraft.archer_pottery_sherd": "Fragmento de cerámica de arco",
  "item.minecraft.armadillo_scute": "Escama de armadillo",
  "item.minecraft.armadillo_spawn_egg": "Generar armadillo",
  "item.minecraft.armor_stand": "Soporte para armadura",
  "item.minecraft.arms_up_pottery_shard": "Fragmento de cerámica de monigote",
  "item.minecraft.arms_up_pottery_sherd": "Fragmento de cerámica de monigote",
  "item.minecraft.arrow": "Flecha",
  "item.minecraft.axolotl_bucket": "Cubo con ajolote",
  "item.minecraft.axolotl_spawn_egg": "Generar ajolote",
  "item.minecraft.baked_potato": "Patata cocida",
  "item.minecraft.bamboo_chest_raft": "Balsa de bambú con cofre",
  "item.minecraft.bamboo_raft": "Balsa de bambú",
  "item.minecraft.bat_spawn_egg": "Generar murciélago",
  "item.minecraft.bee_spawn_egg": "Generar abeja",
  "item.minecraft.beef": "Filete crudo",
  "item.minecraft.beetroot": "Remolacha",
  "item.minecraft.beetroot_seeds": "Semillas de remolacha",
  "item.minecraft.beetroot_soup": "Estofado de remolacha",
  "item.minecraft.birch_boat": "Barca de abedul",
  "item.minecraft.birch_chest_boat": "Barca de abedul con cofre",
  "item.minecraft.black_bundle": "Saco negro",
  "item.minecraft.black_dye": "Tinte negro",
  "item.minecraft.black_harness": "Arnés negro",
  "item.minecraft.blade_pottery_shard": "Fragmento de cerámica de espada",
  "item.minecraft.blade_pottery_sherd": "Fragmento de cerámica de espada",
  "item.minecraft.blaze_powder": "Polvo de blaze",
  "item.minecraft.blaze_rod": "Vara de blaze",
  "item.minecraft.blaze_spawn_egg": "Generar blaze",
  "item.minecraft.blue_bundle": "Saco azul",
  "item.minecraft.blue_dye": "Tinte azul",
  "item.minecraft.blue_egg": "Huevo azul",
  "item.minecraft.blue_harness": "Arnés azul",
  "item.minecraft.bogged_spawn_egg": "Generar ciénago",
  "item.minecraft.bolt_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Diseño de armadura de remaches",
  "item.minecraft.bone": "Hueso",
  "item.minecraft.bone_meal": "Polvo de hueso",
  "item.minecraft.book": "Libro",
  "item.minecraft.bordure_indented_banner_pattern": "Estampado de bordura dentada",
  "item.minecraft.bow": "Arco",
  "item.minecraft.bowl": "Cuenco",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Vara de breeze",
  "item.minecraft.breeze_spawn_egg": "Generar breeze",
  "item.minecraft.brewer_pottery_shard": "Fragmento de cerámica de poción",
  "item.minecraft.brewer_pottery_sherd": "Fragmento de cerámica de poción",
  "item.minecraft.brewing_stand": "Soporte para pociones",
  "item.minecraft.brick": "Ladrillo",
  "item.minecraft.brown_bundle": "Saco marrón",
  "item.minecraft.brown_dye": "Tinte marrón",
  "item.minecraft.brown_egg": "Huevo marrón",
  "item.minecraft.brown_harness": "Arnés marrón",
  "item.minecraft.brush": "Pincel",
  "item.minecraft.bucket": "Cubo",
  "item.minecraft.bundle": "Saco",
  "item.minecraft.bundle.empty": "Vacío",
  "item.minecraft.bundle.empty.description": "Puede contener una pila mixta de objetos",
  "item.minecraft.bundle.full": "Lleno",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Fragmento de cerámica de fuego",
  "item.minecraft.burn_pottery_sherd": "Fragmento de cerámica de fuego",
  "item.minecraft.camel_husk_spawn_egg": "Generar camello disecado",
  "item.minecraft.camel_spawn_egg": "Generar camello",
  "item.minecraft.carrot": "Zanahoria",
  "item.minecraft.carrot_on_a_stick": "Caña con zanahoria",
  "item.minecraft.cat_spawn_egg": "Generar gato",
  "item.minecraft.cauldron": "Caldero",
  "item.minecraft.cave_spider_spawn_egg": "Generar araña de cueva",
  "item.minecraft.chainmail_boots": "Botas de cota de mallas",
  "item.minecraft.chainmail_chestplate": "Peto de cota de mallas",
  "item.minecraft.chainmail_helmet": "Casco de cota de mallas",
  "item.minecraft.chainmail_leggings": "Grebas de cota de mallas",
  "item.minecraft.charcoal": "Carbón vegetal",
  "item.minecraft.cherry_boat": "Barca de cerezo",
  "item.minecraft.cherry_chest_boat": "Barca de cerezo con cofre",
  "item.minecraft.chest_minecart": "Vagoneta con cofre",
  "item.minecraft.chicken": "Pollo crudo",
  "item.minecraft.chicken_spawn_egg": "Generar pollo",
  "item.minecraft.chorus_fruit": "Fruta chorus",
  "item.minecraft.clay_ball": "Bola de arcilla",
  "item.minecraft.clock": "Reloj",
  "item.minecraft.coal": "Carbón",
  "item.minecraft.coast_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Diseño de armadura costera",
  "item.minecraft.cocoa_beans": "Semillas de cacao",
  "item.minecraft.cod": "Bacalao crudo",
  "item.minecraft.cod_bucket": "Cubo con bacalao",
  "item.minecraft.cod_spawn_egg": "Generar bacalao",
  "item.minecraft.command_block_minecart": "Vagoneta con bloque de comandos",
  "item.minecraft.compass": "Brújula",
  "item.minecraft.cooked_beef": "Filete asado",
  "item.minecraft.cooked_chicken": "Pollo asado",
  "item.minecraft.cooked_cod": "Bacalao cocinado",
  "item.minecraft.cooked_mutton": "Cordero asado",
  "item.minecraft.cooked_porkchop": "Chuleta de cerdo cocinada",
  "item.minecraft.cooked_rabbit": "Conejo asado",
  "item.minecraft.cooked_salmon": "Salmón ahumado",
  "item.minecraft.cookie": "Galleta",
  "item.minecraft.copper_axe": "Hacha de cobre",
  "item.minecraft.copper_boots": "Botas de cobre",
  "item.minecraft.copper_chestplate": "Peto de cobre",
  "item.minecraft.copper_golem_spawn_egg": "Generar gólem de cobre",
  "item.minecraft.copper_helmet": "Casco de cobre",
  "item.minecraft.copper_hoe": "Azada de cobre",
  "item.minecraft.copper_horse_armor": "Armadura de cobre para caballo",
  "item.minecraft.copper_ingot": "Lingote de cobre",
  "item.minecraft.copper_leggings": "Grebas de cobre",
  "item.minecraft.copper_nautilus_armor": "Armadura de cobre para nautilo",
  "item.minecraft.copper_nugget": "Pepita de cobre",
  "item.minecraft.copper_pickaxe": "Pico de cobre",
  "item.minecraft.copper_shovel": "Pala de cobre",
  "item.minecraft.copper_spear": "Lanza de cobre",
  "item.minecraft.copper_sword": "Espada de cobre",
  "item.minecraft.cow_spawn_egg": "Generar vaca",
  "item.minecraft.creaking_spawn_egg": "Generar crepitante",
  "item.minecraft.creeper_banner_pattern": "Diseño de estandarte",
  "item.minecraft.creeper_banner_pattern.desc": "Estampado de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Estampado de creeper",
  "item.minecraft.creeper_spawn_egg": "Generar creeper",
  "item.minecraft.crossbow": "Ballesta",
  "item.minecraft.crossbow.projectile": "Proyectil:",
  "item.minecraft.crossbow.projectile.multiple": "Proyectil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Proyectil: %s",
  "item.minecraft.cyan_bundle": "Saco cian",
  "item.minecraft.cyan_dye": "Tinte cian",
  "item.minecraft.cyan_harness": "Arnés cian",
  "item.minecraft.danger_pottery_shard": "Fragmento de cerámica de creeper",
  "item.minecraft.danger_pottery_sherd": "Fragmento de cerámica de creeper",
  "item.minecraft.dark_oak_boat": "Barca de roble oscuro",
  "item.minecraft.dark_oak_chest_boat": "Barca de roble oscuro con cofre",
  "item.minecraft.debug_stick": "Palo de desarrollo",
  "item.minecraft.debug_stick.empty": "%s no tiene propiedades",
  "item.minecraft.debug_stick.select": "se ha seleccionado «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» a %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Hacha de diamante",
  "item.minecraft.diamond_boots": "Botas de diamante",
  "item.minecraft.diamond_chestplate": "Peto de diamante",
  "item.minecraft.diamond_helmet": "Casco de diamante",
  "item.minecraft.diamond_hoe": "Azada de diamante",
  "item.minecraft.diamond_horse_armor": "Armadura de diamante para caballo",
  "item.minecraft.diamond_leggings": "Grebas de diamante",
  "item.minecraft.diamond_nautilus_armor": "Armadura de diamante para nautilo",
  "item.minecraft.diamond_pickaxe": "Pico de diamante",
  "item.minecraft.diamond_shovel": "Pala de diamante",
  "item.minecraft.diamond_spear": "Lanza de diamante",
  "item.minecraft.diamond_sword": "Espada de diamante",
  "item.minecraft.disc_fragment_5": "Fragmento de disco",
  "item.minecraft.disc_fragment_5.desc": "Disco de música - 5",
  "item.minecraft.dolphin_spawn_egg": "Generar delfín",
  "item.minecraft.donkey_spawn_egg": "Generar burro",
  "item.minecraft.dragon_breath": "Aliento de dragón",
  "item.minecraft.dried_kelp": "Algas secas",
  "item.minecraft.drowned_spawn_egg": "Generar ahogado",
  "item.minecraft.dune_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Diseño de armadura de las dunas",
  "item.minecraft.echo_shard": "Fragmento resonante",
  "item.minecraft.egg": "Huevo",
  "item.minecraft.elder_guardian_spawn_egg": "Generar guardián anciano",
  "item.minecraft.elytra": "Élitros",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Libro encantado",
  "item.minecraft.enchanted_golden_apple": "Manzana dorada encantada",
  "item.minecraft.end_crystal": "Cristal del End",
  "item.minecraft.ender_dragon_spawn_egg": "Generar Enderdragón",
  "item.minecraft.ender_eye": "Ojo de ender",
  "item.minecraft.ender_pearl": "Perla de ender",
  "item.minecraft.enderman_spawn_egg": "Generar enderman",
  "item.minecraft.endermite_spawn_egg": "Generar endermite",
  "item.minecraft.evoker_spawn_egg": "Generar evocador",
  "item.minecraft.experience_bottle": "Frasco con experiencia",
  "item.minecraft.explorer_pottery_shard": "Fragmento de cerámica de mapa",
  "item.minecraft.explorer_pottery_sherd": "Fragmento de cerámica de mapa",
  "item.minecraft.eye_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Diseño de armadura de ojos",
  "item.minecraft.feather": "Pluma",
  "item.minecraft.fermented_spider_eye": "Ojo de araña fermentado",
  "item.minecraft.field_masoned_banner_pattern": "Estampado de mazonado",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Carga ígnea",
  "item.minecraft.firework_rocket": "Cohete de fuegos artificiales",
  "item.minecraft.firework_rocket.flight": "Duración del vuelo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Estrella de fuegos artificiales",
  "item.minecraft.firework_star.black": "negra",
  "item.minecraft.firework_star.blue": "azul",
  "item.minecraft.firework_star.brown": "marrón",
  "item.minecraft.firework_star.custom_color": "Personalizado",
  "item.minecraft.firework_star.cyan": "cian",
  "item.minecraft.firework_star.fade_to": "Se vuelve",
  "item.minecraft.firework_star.flicker": "Centelleo",
  "item.minecraft.firework_star.gray": "gris",
  "item.minecraft.firework_star.green": "verde",
  "item.minecraft.firework_star.light_blue": "azul claro",
  "item.minecraft.firework_star.light_gray": "gris claro",
  "item.minecraft.firework_star.lime": "verde lima",
  "item.minecraft.firework_star.magenta": "magenta",
  "item.minecraft.firework_star.orange": "naranja",
  "item.minecraft.firework_star.pink": "rosa",
  "item.minecraft.firework_star.purple": "morada",
  "item.minecraft.firework_star.red": "roja",
  "item.minecraft.firework_star.shape": "Forma desconocida",
  "item.minecraft.firework_star.shape.burst": "Explosión",
  "item.minecraft.firework_star.shape.creeper": "Con forma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bola grande",
  "item.minecraft.firework_star.shape.small_ball": "Bola pequeña",
  "item.minecraft.firework_star.shape.star": "Con forma de estrella",
  "item.minecraft.firework_star.trail": "Rastro",
  "item.minecraft.firework_star.white": "blanca",
  "item.minecraft.firework_star.yellow": "amarilla",
  "item.minecraft.fishing_rod": "Caña de pescar",
  "item.minecraft.flint": "Pedernal",
  "item.minecraft.flint_and_steel": "Mechero",
  "item.minecraft.flow_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Diseño de armadura de espiral",
  "item.minecraft.flow_banner_pattern": "Diseño de estandarte",
  "item.minecraft.flow_banner_pattern.desc": "Estampado de espiral",
  "item.minecraft.flow_banner_pattern.new": "Estampado de espiral",
  "item.minecraft.flow_pottery_sherd": "Fragmento de cerámica de espiral",
  "item.minecraft.flower_banner_pattern": "Diseño de estandarte",
  "item.minecraft.flower_banner_pattern.desc": "Estampado de flor",
  "item.minecraft.flower_banner_pattern.new": "Estampado de flor",
  "item.minecraft.flower_pot": "Maceta",
  "item.minecraft.fox_spawn_egg": "Generar zorro",
  "item.minecraft.friend_pottery_shard": "Fragmento de cerámica de amistad",
  "item.minecraft.friend_pottery_sherd": "Fragmento de cerámica de amistad",
  "item.minecraft.frog_spawn_egg": "Generar rana",
  "item.minecraft.furnace_minecart": "Vagoneta con horno",
  "item.minecraft.ghast_spawn_egg": "Generar ghast",
  "item.minecraft.ghast_tear": "Lágrima de ghast",
  "item.minecraft.glass_bottle": "Frasco de cristal",
  "item.minecraft.glistering_melon_slice": "Rodaja de sandía reluciente",
  "item.minecraft.globe_banner_pattern": "Diseño de estandarte",
  "item.minecraft.globe_banner_pattern.desc": "Estampado de planeta",
  "item.minecraft.globe_banner_pattern.new": "Estampado de planeta",
  "item.minecraft.glow_berries": "Bayas luminosas",
  "item.minecraft.glow_ink_sac": "Saco de tinta luminosa",
  "item.minecraft.glow_item_frame": "Marco luminoso",
  "item.minecraft.glow_squid_spawn_egg": "Generar calamar luminoso",
  "item.minecraft.glowstone_dust": "Polvo de piedra luminosa",
  "item.minecraft.goat_horn": "Cuerno de cabra",
  "item.minecraft.goat_spawn_egg": "Generar cabra",
  "item.minecraft.gold_ingot": "Lingote de oro",
  "item.minecraft.gold_nugget": "Pepita de oro",
  "item.minecraft.golden_apple": "Manzana dorada",
  "item.minecraft.golden_axe": "Hacha de oro",
  "item.minecraft.golden_boots": "Botas de oro",
  "item.minecraft.golden_carrot": "Zanahoria dorada",
  "item.minecraft.golden_chestplate": "Peto de oro",
  "item.minecraft.golden_helmet": "Casco de oro",
  "item.minecraft.golden_hoe": "Azada de oro",
  "item.minecraft.golden_horse_armor": "Armadura de oro para caballo",
  "item.minecraft.golden_leggings": "Grebas de oro",
  "item.minecraft.golden_nautilus_armor": "Armadura de oro para nautilo",
  "item.minecraft.golden_pickaxe": "Pico de oro",
  "item.minecraft.golden_shovel": "Pala de oro",
  "item.minecraft.golden_spear": "Lanza de oro",
  "item.minecraft.golden_sword": "Espada de oro",
  "item.minecraft.gray_bundle": "Saco gris",
  "item.minecraft.gray_dye": "Tinte gris",
  "item.minecraft.gray_harness": "Arnés gris",
  "item.minecraft.green_bundle": "Saco verde",
  "item.minecraft.green_dye": "Tinte verde",
  "item.minecraft.green_harness": "Arnés verde",
  "item.minecraft.guardian_spawn_egg": "Generar guardián",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Diseño de estandarte",
  "item.minecraft.guster_banner_pattern.desc": "Estampado de breeze",
  "item.minecraft.guster_banner_pattern.new": "Estampado de breeze",
  "item.minecraft.guster_pottery_sherd": "Fragmento de cerámica de breeze",
  "item.minecraft.happy_ghast_spawn_egg": "Generar ghast feliz",
  "item.minecraft.harness": "Arnés",
  "item.minecraft.heart_of_the_sea": "Corazón del mar",
  "item.minecraft.heart_pottery_shard": "Fragmento de cerámica de corazón",
  "item.minecraft.heart_pottery_sherd": "Fragmento de cerámica de corazón",
  "item.minecraft.heartbreak_pottery_shard": "Fragmento de cerámica de corazón roto",
  "item.minecraft.heartbreak_pottery_sherd": "Fragmento de cerámica de corazón roto",
  "item.minecraft.hoglin_spawn_egg": "Generar hoglin",
  "item.minecraft.honey_bottle": "Frasco con miel",
  "item.minecraft.honeycomb": "Panal",
  "item.minecraft.hopper_minecart": "Vagoneta con tolva",
  "item.minecraft.horse_spawn_egg": "Generar caballo",
  "item.minecraft.host_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.host_armor_trim_smithing_template.new": "Diseño de armadura de anfitrión",
  "item.minecraft.howl_pottery_shard": "Fragmento de cerámica de lobo",
  "item.minecraft.howl_pottery_sherd": "Fragmento de cerámica de lobo",
  "item.minecraft.husk_spawn_egg": "Generar disecado",
  "item.minecraft.ink_sac": "Saco de tinta",
  "item.minecraft.iron_axe": "Hacha de hierro",
  "item.minecraft.iron_boots": "Botas de hierro",
  "item.minecraft.iron_chestplate": "Peto de hierro",
  "item.minecraft.iron_golem_spawn_egg": "Generar gólem de hierro",
  "item.minecraft.iron_helmet": "Casco de hierro",
  "item.minecraft.iron_hoe": "Azada de hierro",
  "item.minecraft.iron_horse_armor": "Armadura de hierro para caballo",
  "item.minecraft.iron_ingot": "Lingote de hierro",
  "item.minecraft.iron_leggings": "Grebas de hierro",
  "item.minecraft.iron_nautilus_armor": "Armadura de hierro para nautilo",
  "item.minecraft.iron_nugget": "Pepita de hierro",
  "item.minecraft.iron_pickaxe": "Pico de hierro",
  "item.minecraft.iron_shovel": "Pala de hierro",
  "item.minecraft.iron_spear": "Lanza de hierro",
  "item.minecraft.iron_sword": "Espada de hierro",
  "item.minecraft.item_frame": "Marco",
  "item.minecraft.jungle_boat": "Barca de jungla",
  "item.minecraft.jungle_chest_boat": "Barca de jungla con cofre",
  "item.minecraft.knowledge_book": "Enciclopedia",
  "item.minecraft.lapis_lazuli": "Lapislázuli",
  "item.minecraft.lava_bucket": "Cubo con lava",
  "item.minecraft.lead": "Rienda",
  "item.minecraft.leather": "Cuero",
  "item.minecraft.leather_boots": "Botas de cuero",
  "item.minecraft.leather_chestplate": "Túnica de cuero",
  "item.minecraft.leather_helmet": "Sombrero de cuero",
  "item.minecraft.leather_horse_armor": "Armadura de cuero para caballo",
  "item.minecraft.leather_leggings": "Pantalones de cuero",
  "item.minecraft.light_blue_bundle": "Saco azul claro",
  "item.minecraft.light_blue_dye": "Tinte azul claro",
  "item.minecraft.light_blue_harness": "Arnés azul claro",
  "item.minecraft.light_gray_bundle": "Saco gris claro",
  "item.minecraft.light_gray_dye": "Tinte gris claro",
  "item.minecraft.light_gray_harness": "Arnés gris claro",
  "item.minecraft.lime_bundle": "Saco verde lima",
  "item.minecraft.lime_dye": "Tinte verde lima",
  "item.minecraft.lime_harness": "Arnés verde lima",
  "item.minecraft.lingering_potion": "Poción persistente",
  "item.minecraft.lingering_potion.effect.awkward": "Poción rara persistente",
  "item.minecraft.lingering_potion.effect.empty": "Poción persistente no fabricable",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Poción de cuerpo ignífugo persistente",
  "item.minecraft.lingering_potion.effect.harming": "Poción de daño persistente",
  "item.minecraft.lingering_potion.effect.healing": "Poción de curación persistente",
  "item.minecraft.lingering_potion.effect.infested": "Poción de infestación persistente",
  "item.minecraft.lingering_potion.effect.invisibility": "Poción de invisibilidad persistente",
  "item.minecraft.lingering_potion.effect.leaping": "Poción de salto persistente",
  "item.minecraft.lingering_potion.effect.levitation": "Poción de levitación persistente",
  "item.minecraft.lingering_potion.effect.luck": "Poción de suerte persistente",
  "item.minecraft.lingering_potion.effect.mundane": "Poción vulgar persistente",
  "item.minecraft.lingering_potion.effect.night_vision": "Poción de visión nocturna persistente",
  "item.minecraft.lingering_potion.effect.oozing": "Poción de mucosidad persistente",
  "item.minecraft.lingering_potion.effect.poison": "Poción de veneno persistente",
  "item.minecraft.lingering_potion.effect.regeneration": "Poción de regeneración persistente",
  "item.minecraft.lingering_potion.effect.slow_falling": "Poción de caída lenta persistente",
  "item.minecraft.lingering_potion.effect.slowness": "Poción de lentitud persistente",
  "item.minecraft.lingering_potion.effect.strength": "Poción de fuerza persistente",
  "item.minecraft.lingering_potion.effect.swiftness": "Poción de rapidez persistente",
  "item.minecraft.lingering_potion.effect.thick": "Poción densa persistente",
  "item.minecraft.lingering_potion.effect.turtle_master": "Poción del maestro tortuga persistente",
  "item.minecraft.lingering_potion.effect.water": "Frasco con agua persistente",
  "item.minecraft.lingering_potion.effect.water_breathing": "Poción de apnea persistente",
  "item.minecraft.lingering_potion.effect.weakness": "Poción de debilidad persistente",
  "item.minecraft.lingering_potion.effect.weaving": "Poción de tejedura persistente",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poción de cierzo persistente",
  "item.minecraft.llama_spawn_egg": "Generar llama",
  "item.minecraft.lodestone_compass": "Brújula imantada",
  "item.minecraft.mace": "Maza",
  "item.minecraft.magenta_bundle": "Saco magenta",
  "item.minecraft.magenta_dye": "Tinte magenta",
  "item.minecraft.magenta_harness": "Arnés magenta",
  "item.minecraft.magma_cream": "Crema de magma",
  "item.minecraft.magma_cube_spawn_egg": "Generar cubo de magma",
  "item.minecraft.mangrove_boat": "Barca de mangle",
  "item.minecraft.mangrove_chest_boat": "Barca de mangle con cofre",
  "item.minecraft.map": "Mapa en blanco",
  "item.minecraft.melon_seeds": "Semillas de sandía",
  "item.minecraft.melon_slice": "Rodaja de sandía",
  "item.minecraft.milk_bucket": "Cubo con leche",
  "item.minecraft.minecart": "Vagoneta",
  "item.minecraft.miner_pottery_shard": "Fragmento de cerámica de pico",
  "item.minecraft.miner_pottery_sherd": "Fragmento de cerámica de pico",
  "item.minecraft.mojang_banner_pattern": "Diseño de estandarte",
  "item.minecraft.mojang_banner_pattern.desc": "Estampado de Mojang",
  "item.minecraft.mojang_banner_pattern.new": "Estampado de Mojang",
  "item.minecraft.mooshroom_spawn_egg": "Generar mooshroom",
  "item.minecraft.mourner_pottery_shard": "Fragmento de cerámica de warden",
  "item.minecraft.mourner_pottery_sherd": "Fragmento de cerámica de warden",
  "item.minecraft.mule_spawn_egg": "Generar mula",
  "item.minecraft.mushroom_stew": "Estofado de champiñones",
  "item.minecraft.music_disc_11": "Disco de música",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disco de música",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disco de música",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disco de música",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disco de música",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disco de música",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disco de música",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disco de música",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (caja de música)",
  "item.minecraft.music_disc_far": "Disco de música",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disco de música",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disco de música",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disco de música",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disco de música",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disco de música",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disco de música",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disco de música",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disco de música",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disco de música",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disco de música",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disco de música",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disco de música",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Cordero crudo",
  "item.minecraft.name_tag": "Etiqueta",
  "item.minecraft.nautilus_shell": "Caparazón de nautilo",
  "item.minecraft.nautilus_spawn_egg": "Generar nautilo",
  "item.minecraft.nether_brick": "Ladrillo del Nether",
  "item.minecraft.nether_star": "Estrella del Nether",
  "item.minecraft.nether_wart": "Verruga del Nether",
  "item.minecraft.netherite_axe": "Hacha de netherita",
  "item.minecraft.netherite_boots": "Botas de netherita",
  "item.minecraft.netherite_chestplate": "Peto de netherita",
  "item.minecraft.netherite_helmet": "Casco de netherita",
  "item.minecraft.netherite_hoe": "Azada de netherita",
  "item.minecraft.netherite_horse_armor": "Armadura de netherita para caballo",
  "item.minecraft.netherite_ingot": "Lingote de netherita",
  "item.minecraft.netherite_leggings": "Grebas de netherita",
  "item.minecraft.netherite_nautilus_armor": "Armadura de netherita para nautilo",
  "item.minecraft.netherite_pickaxe": "Pico de netherita",
  "item.minecraft.netherite_scrap": "Fragmentos de netherita",
  "item.minecraft.netherite_shovel": "Pala de netherita",
  "item.minecraft.netherite_spear": "Lanza de netherita",
  "item.minecraft.netherite_sword": "Espada de netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Molde de herrería",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Mejora de netherita",
  "item.minecraft.oak_boat": "Barca de roble",
  "item.minecraft.oak_chest_boat": "Barca de roble con cofre",
  "item.minecraft.ocelot_spawn_egg": "Generar ocelote",
  "item.minecraft.ominous_bottle": "Frasco ominoso",
  "item.minecraft.ominous_trial_key": "Llave de desafío ominosa",
  "item.minecraft.orange_bundle": "Saco naranja",
  "item.minecraft.orange_dye": "Tinte naranja",
  "item.minecraft.orange_harness": "Arnés naranja",
  "item.minecraft.painting": "Cuadro",
  "item.minecraft.pale_oak_boat": "Barca de roble pálido",
  "item.minecraft.pale_oak_chest_boat": "Barca de roble pálido con cofre",
  "item.minecraft.panda_spawn_egg": "Generar panda",
  "item.minecraft.paper": "Papel",
  "item.minecraft.parched_spawn_egg": "Generar momificado",
  "item.minecraft.parrot_spawn_egg": "Generar loro",
  "item.minecraft.phantom_membrane": "Membrana de fantasma",
  "item.minecraft.phantom_spawn_egg": "Generar fantasma",
  "item.minecraft.pig_spawn_egg": "Generar cerdo",
  "item.minecraft.piglin_banner_pattern": "Diseño de estandarte",
  "item.minecraft.piglin_banner_pattern.desc": "Estampado de hocico",
  "item.minecraft.piglin_banner_pattern.new": "Estampado de hocico",
  "item.minecraft.piglin_brute_spawn_egg": "Generar piglin bruto",
  "item.minecraft.piglin_spawn_egg": "Generar piglin",
  "item.minecraft.pillager_spawn_egg": "Generar saqueador",
  "item.minecraft.pink_bundle": "Saco rosa",
  "item.minecraft.pink_dye": "Tinte rosa",
  "item.minecraft.pink_harness": "Arnés rosa",
  "item.minecraft.pitcher_plant": "Planta odre",
  "item.minecraft.pitcher_pod": "Vaina de planta odre",
  "item.minecraft.plenty_pottery_shard": "Fragmento de cerámica de cofre",
  "item.minecraft.plenty_pottery_sherd": "Fragmento de cerámica de cofre",
  "item.minecraft.poisonous_potato": "Patata venenosa",
  "item.minecraft.polar_bear_spawn_egg": "Generar oso polar",
  "item.minecraft.popped_chorus_fruit": "Fruta chorus horneada",
  "item.minecraft.porkchop": "Chuleta de cerdo cruda",
  "item.minecraft.potato": "Patata",
  "item.minecraft.potion": "Poción",
  "item.minecraft.potion.effect.awkward": "Poción rara",
  "item.minecraft.potion.effect.empty": "Poción no fabricable",
  "item.minecraft.potion.effect.fire_resistance": "Poción de cuerpo ignífugo",
  "item.minecraft.potion.effect.harming": "Poción de daño",
  "item.minecraft.potion.effect.healing": "Poción de curación",
  "item.minecraft.potion.effect.infested": "Poción de infestación",
  "item.minecraft.potion.effect.invisibility": "Poción de invisibilidad",
  "item.minecraft.potion.effect.leaping": "Poción de salto",
  "item.minecraft.potion.effect.levitation": "Poción de levitación",
  "item.minecraft.potion.effect.luck": "Poción de suerte",
  "item.minecraft.potion.effect.mundane": "Poción vulgar",
  "item.minecraft.potion.effect.night_vision": "Poción de visión nocturna",
  "item.minecraft.potion.effect.oozing": "Poción de mucosidad",
  "item.minecraft.potion.effect.poison": "Poción de veneno",
  "item.minecraft.potion.effect.regeneration": "Poción de regeneración",
  "item.minecraft.potion.effect.slow_falling": "Poción de caída lenta",
  "item.minecraft.potion.effect.slowness": "Poción de lentitud",
  "item.minecraft.potion.effect.strength": "Poción de fuerza",
  "item.minecraft.potion.effect.swiftness": "Poción de rapidez",
  "item.minecraft.potion.effect.thick": "Poción densa",
  "item.minecraft.potion.effect.turtle_master": "Poción del maestro tortuga",
  "item.minecraft.potion.effect.water": "Frasco con agua",
  "item.minecraft.potion.effect.water_breathing": "Poción de apnea",
  "item.minecraft.potion.effect.weakness": "Poción de debilidad",
  "item.minecraft.potion.effect.weaving": "Poción de tejedura",
  "item.minecraft.potion.effect.wind_charged": "Poción de cierzo",
  "item.minecraft.pottery_shard_archer": "Fragmento de cerámica de arco",
  "item.minecraft.pottery_shard_arms_up": "Fragmento de cerámica de monigote",
  "item.minecraft.pottery_shard_prize": "Fragmento de cerámica de gema",
  "item.minecraft.pottery_shard_skull": "Fragmento de cerámica de calavera",
  "item.minecraft.powder_snow_bucket": "Cubo con nieve polvo",
  "item.minecraft.prismarine_crystals": "Cristales de prismarina",
  "item.minecraft.prismarine_shard": "Fragmento de prismarina",
  "item.minecraft.prize_pottery_shard": "Fragmento de cerámica de gema",
  "item.minecraft.prize_pottery_sherd": "Fragmento de cerámica de gema",
  "item.minecraft.pufferfish": "Pez globo",
  "item.minecraft.pufferfish_bucket": "Cubo con pez globo",
  "item.minecraft.pufferfish_spawn_egg": "Generar pez globo",
  "item.minecraft.pumpkin_pie": "Tarta de calabaza",
  "item.minecraft.pumpkin_seeds": "Semillas de calabaza",
  "item.minecraft.purple_bundle": "Saco morado",
  "item.minecraft.purple_dye": "Tinte morado",
  "item.minecraft.purple_harness": "Arnés morado",
  "item.minecraft.quartz": "Cuarzo del Nether",
  "item.minecraft.rabbit": "Conejo crudo",
  "item.minecraft.rabbit_foot": "Pata de conejo",
  "item.minecraft.rabbit_hide": "Piel de conejo",
  "item.minecraft.rabbit_spawn_egg": "Generar conejo",
  "item.minecraft.rabbit_stew": "Estofado de conejo",
  "item.minecraft.raiser_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Diseño de armadura de elevación",
  "item.minecraft.ravager_spawn_egg": "Generar devastador",
  "item.minecraft.raw_copper": "Cobre en bruto",
  "item.minecraft.raw_gold": "Oro en bruto",
  "item.minecraft.raw_iron": "Hierro en bruto",
  "item.minecraft.recovery_compass": "Brújula de recuperación",
  "item.minecraft.red_bundle": "Saco rojo",
  "item.minecraft.red_dye": "Tinte rojo",
  "item.minecraft.red_harness": "Arnés rojo",
  "item.minecraft.redstone": "Polvo de redstone",
  "item.minecraft.resin_brick": "Ladrillo de resina",
  "item.minecraft.resin_clump": "Grumo de resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Diseño de armadura de costillas",
  "item.minecraft.rotten_flesh": "Carne podrida",
  "item.minecraft.saddle": "Montura",
  "item.minecraft.salmon": "Salmón crudo",
  "item.minecraft.salmon_bucket": "Cubo con salmón",
  "item.minecraft.salmon_spawn_egg": "Generar salmón",
  "item.minecraft.scrape_pottery_sherd": "Fragmento de cerámica de hacha",
  "item.minecraft.scute": "Escama",
  "item.minecraft.sentry_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Diseño de armadura de centinela",
  "item.minecraft.shaper_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Diseño de armadura de modelador",
  "item.minecraft.sheaf_pottery_shard": "Fragmento de cerámica de paja",
  "item.minecraft.sheaf_pottery_sherd": "Fragmento de cerámica de paja",
  "item.minecraft.shears": "Tijeras",
  "item.minecraft.sheep_spawn_egg": "Generar oveja",
  "item.minecraft.shelter_pottery_shard": "Fragmento de cerámica de refugio",
  "item.minecraft.shelter_pottery_sherd": "Fragmento de cerámica de refugio",
  "item.minecraft.shield": "Escudo",
  "item.minecraft.shield.black": "Escudo negro",
  "item.minecraft.shield.blue": "Escudo azul",
  "item.minecraft.shield.brown": "Escudo marrón",
  "item.minecraft.shield.cyan": "Escudo cian",
  "item.minecraft.shield.gray": "Escudo gris",
  "item.minecraft.shield.green": "Escudo verde",
  "item.minecraft.shield.light_blue": "Escudo azul claro",
  "item.minecraft.shield.light_gray": "Escudo gris claro",
  "item.minecraft.shield.lime": "Escudo verde lima",
  "item.minecraft.shield.magenta": "Escudo magenta",
  "item.minecraft.shield.orange": "Escudo naranja",
  "item.minecraft.shield.pink": "Escudo rosa",
  "item.minecraft.shield.purple": "Escudo morado",
  "item.minecraft.shield.red": "Escudo rojo",
  "item.minecraft.shield.white": "Escudo blanco",
  "item.minecraft.shield.yellow": "Escudo amarillo",
  "item.minecraft.shulker_shell": "Caparazón de shulker",
  "item.minecraft.shulker_spawn_egg": "Generar shulker",
  "item.minecraft.sign": "Cartel",
  "item.minecraft.silence_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Diseño de armadura de silencio",
  "item.minecraft.silverfish_spawn_egg": "Generar lepisma",
  "item.minecraft.skeleton_horse_spawn_egg": "Generar caballo esqueleto",
  "item.minecraft.skeleton_spawn_egg": "Generar esqueleto",
  "item.minecraft.skull_banner_pattern": "Diseño de estandarte",
  "item.minecraft.skull_banner_pattern.desc": "Estampado de calavera",
  "item.minecraft.skull_banner_pattern.new": "Estampado de calavera",
  "item.minecraft.skull_pottery_shard": "Fragmento de cerámica de calavera",
  "item.minecraft.skull_pottery_sherd": "Fragmento de cerámica de calavera",
  "item.minecraft.slime_ball": "Bola de slime",
  "item.minecraft.slime_spawn_egg": "Generar slime",
  "item.minecraft.smithing_template": "Molde de herrería",
  "item.minecraft.smithing_template.applies_to": "Se aplica a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Añade un lingote o cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armaduras",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Añade una pieza de armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingotes y cristales",
  "item.minecraft.smithing_template.ingredients": "Ingredientes:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Añade un lingote de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipamiento de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Añade una armadura, arma o herramienta de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingote de netherita",
  "item.minecraft.smithing_template.upgrade": "Mejora: ",
  "item.minecraft.sniffer_spawn_egg": "Generar sniffer",
  "item.minecraft.snort_pottery_shard": "Fragmento de cerámica de sniffer",
  "item.minecraft.snort_pottery_sherd": "Fragmento de cerámica de sniffer",
  "item.minecraft.snout_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Diseño de armadura de hocico",
  "item.minecraft.snow_golem_spawn_egg": "Generar gólem de nieve",
  "item.minecraft.snowball": "Bola de nieve",
  "item.minecraft.spectral_arrow": "Flecha espectral",
  "item.minecraft.spider_eye": "Ojo de araña",
  "item.minecraft.spider_spawn_egg": "Generar araña",
  "item.minecraft.spire_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Diseño de armadura de agujas",
  "item.minecraft.splash_potion": "Poción arrojadiza",
  "item.minecraft.splash_potion.effect.awkward": "Poción rara arrojadiza",
  "item.minecraft.splash_potion.effect.empty": "Poción arrojadiza no fabricable",
  "item.minecraft.splash_potion.effect.fire_resistance": "Poción de cuerpo ignífugo arrojadiza",
  "item.minecraft.splash_potion.effect.harming": "Poción de daño arrojadiza",
  "item.minecraft.splash_potion.effect.healing": "Poción de curación arrojadiza",
  "item.minecraft.splash_potion.effect.infested": "Poción de infestación arrojadiza",
  "item.minecraft.splash_potion.effect.invisibility": "Poción de invisibilidad arrojadiza",
  "item.minecraft.splash_potion.effect.leaping": "Poción de salto arrojadiza",
  "item.minecraft.splash_potion.effect.levitation": "Poción de levitación arrojadiza",
  "item.minecraft.splash_potion.effect.luck": "Poción de suerte arrojadiza",
  "item.minecraft.splash_potion.effect.mundane": "Poción vulgar arrojadiza",
  "item.minecraft.splash_potion.effect.night_vision": "Poción de visión nocturna arrojadiza",
  "item.minecraft.splash_potion.effect.oozing": "Poción de mucosidad arrojadiza",
  "item.minecraft.splash_potion.effect.poison": "Poción de veneno arrojadiza",
  "item.minecraft.splash_potion.effect.regeneration": "Poción de regeneración arrojadiza",
  "item.minecraft.splash_potion.effect.slow_falling": "Poción de caída lenta arrojadiza",
  "item.minecraft.splash_potion.effect.slowness": "Poción de lentitud arrojadiza",
  "item.minecraft.splash_potion.effect.strength": "Poción de fuerza arrojadiza",
  "item.minecraft.splash_potion.effect.swiftness": "Poción de rapidez arrojadiza",
  "item.minecraft.splash_potion.effect.thick": "Poción densa arrojadiza",
  "item.minecraft.splash_potion.effect.turtle_master": "Poción del maestro tortuga arrojadiza",
  "item.minecraft.splash_potion.effect.water": "Frasco con agua arrojadizo",
  "item.minecraft.splash_potion.effect.water_breathing": "Poción de apnea arrojadiza",
  "item.minecraft.splash_potion.effect.weakness": "Poción de debilidad arrojadiza",
  "item.minecraft.splash_potion.effect.weaving": "Poción de tejedura arrojadiza",
  "item.minecraft.splash_potion.effect.wind_charged": "Poción de cierzo arrojadiza",
  "item.minecraft.spruce_boat": "Barca de abeto",
  "item.minecraft.spruce_chest_boat": "Barca de abeto con cofre",
  "item.minecraft.spyglass": "Catalejo",
  "item.minecraft.squid_spawn_egg": "Generar calamar",
  "item.minecraft.stick": "Palo",
  "item.minecraft.stone_axe": "Hacha de piedra",
  "item.minecraft.stone_hoe": "Azada de piedra",
  "item.minecraft.stone_pickaxe": "Pico de piedra",
  "item.minecraft.stone_shovel": "Pala de piedra",
  "item.minecraft.stone_spear": "Lanza de piedra",
  "item.minecraft.stone_sword": "Espada de piedra",
  "item.minecraft.stray_spawn_egg": "Generar errante",
  "item.minecraft.strider_spawn_egg": "Generar lavagante",
  "item.minecraft.string": "Hilo",
  "item.minecraft.sugar": "Azúcar",
  "item.minecraft.suspicious_stew": "Estofado sospechoso",
  "item.minecraft.sweet_berries": "Bayas dulces",
  "item.minecraft.tadpole_bucket": "Cubo con renacuajo",
  "item.minecraft.tadpole_spawn_egg": "Generar renacuajo",
  "item.minecraft.tide_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Diseño de armadura de la marea",
  "item.minecraft.tipped_arrow": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.awkward": "Flecha con agua rara",
  "item.minecraft.tipped_arrow.effect.empty": "Flecha con efecto no fabricable",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flecha de cuerpo ignífugo",
  "item.minecraft.tipped_arrow.effect.harming": "Flecha de daño",
  "item.minecraft.tipped_arrow.effect.healing": "Flecha de curación",
  "item.minecraft.tipped_arrow.effect.infested": "Flecha de infestación",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flecha de invisibilidad",
  "item.minecraft.tipped_arrow.effect.leaping": "Flecha de salto",
  "item.minecraft.tipped_arrow.effect.levitation": "Flecha de levitación",
  "item.minecraft.tipped_arrow.effect.luck": "Flecha de suerte",
  "item.minecraft.tipped_arrow.effect.mundane": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flecha de visión nocturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Flecha de mucosidad",
  "item.minecraft.tipped_arrow.effect.poison": "Flecha de veneno",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flecha de regeneración",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flecha de caída lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Flecha de lentitud",
  "item.minecraft.tipped_arrow.effect.strength": "Flecha de fuerza",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flecha de rapidez",
  "item.minecraft.tipped_arrow.effect.thick": "Flecha con agua densa",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flecha del maestro tortuga",
  "item.minecraft.tipped_arrow.effect.water": "Flecha de salpicadura",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flecha de apnea",
  "item.minecraft.tipped_arrow.effect.weakness": "Flecha de debilidad",
  "item.minecraft.tipped_arrow.effect.weaving": "Flecha de tejedura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Flecha de cierzo",
  "item.minecraft.tnt_minecart": "Vagoneta con dinamita",
  "item.minecraft.torchflower_seeds": "Semillas de plantorcha",
  "item.minecraft.totem_of_undying": "Tótem de inmortalidad",
  "item.minecraft.trader_llama_spawn_egg": "Generar llama ambulante",
  "item.minecraft.trial_key": "Llave de desafío",
  "item.minecraft.trident": "Tridente",
  "item.minecraft.tropical_fish": "Pez tropical",
  "item.minecraft.tropical_fish_bucket": "Cubo con pez tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Generar pez tropical",
  "item.minecraft.turtle_helmet": "Caparazón de tortuga",
  "item.minecraft.turtle_scute": "Escama de tortuga",
  "item.minecraft.turtle_spawn_egg": "Generar tortuga",
  "item.minecraft.vex_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Diseño de armadura de vex",
  "item.minecraft.vex_spawn_egg": "Generar vex",
  "item.minecraft.villager_spawn_egg": "Generar aldeano",
  "item.minecraft.vindicator_spawn_egg": "Generar vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "Generar vendedor ambulante",
  "item.minecraft.ward_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Diseño de armadura de warden",
  "item.minecraft.warden_spawn_egg": "Generar warden",
  "item.minecraft.warped_fungus_on_a_stick": "Caña con hongo distorsionado",
  "item.minecraft.water_bucket": "Cubo con agua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Diseño de armadura de buscacaminos",
  "item.minecraft.wheat": "Trigo",
  "item.minecraft.wheat_seeds": "Semillas de trigo",
  "item.minecraft.white_bundle": "Saco blanco",
  "item.minecraft.white_dye": "Tinte blanco",
  "item.minecraft.white_harness": "Arnés blanco",
  "item.minecraft.wild_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Diseño de armadura salvaje",
  "item.minecraft.wind_charge": "Carga de viento",
  "item.minecraft.witch_spawn_egg": "Generar bruja",
  "item.minecraft.wither_skeleton_spawn_egg": "Generar esqueleto del Wither",
  "item.minecraft.wither_spawn_egg": "Generar Wither",
  "item.minecraft.wolf_armor": "Armadura para lobo",
  "item.minecraft.wolf_spawn_egg": "Generar lobo",
  "item.minecraft.wooden_axe": "Hacha de madera",
  "item.minecraft.wooden_hoe": "Azada de madera",
  "item.minecraft.wooden_pickaxe": "Pico de madera",
  "item.minecraft.wooden_shovel": "Pala de madera",
  "item.minecraft.wooden_spear": "Lanza de madera",
  "item.minecraft.wooden_sword": "Espada de madera",
  "item.minecraft.writable_book": "Libro y pluma",
  "item.minecraft.written_book": "Libro escrito",
  "item.minecraft.yellow_bundle": "Saco amarillo",
  "item.minecraft.yellow_dye": "Tinte amarillo",
  "item.minecraft.yellow_harness": "Arnés amarillo",
  "item.minecraft.zoglin_spawn_egg": "Generar zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Generar caballo zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Generar nautilo zombi",
  "item.minecraft.zombie_spawn_egg": "Generar zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Generar aldeano zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Generar piglin zombificado"
}
export const es_es = items; 
